import React, { useEffect, useState,useRef } from "react";
import MultiDatePicker from "react-multi-date-picker";
import moment, { lang } from "moment-timezone";
import "./goondemand.css";
import { useDispatch, useSelector } from "react-redux";
import Questions from "./questionsbox";
import ScheduledetailsModal from "../../admin/ondemandupdates/scheduledetails";
import VideoPopUp from "../../overviewmedium/videopopup";
import SeVideoPopUp from "../../overviewmedium/sevideopopup";
import TimeDisplay from "../../../components/TimeDisplay";
import "../../../components/TimeDisplay.css";
import { format, set } from 'date-fns';
import {
    acceptOnDemandSession,
    addMediumToOnDemandQueue,
    bookOnDemandSession,
    checkMediumInOnDemandQueue,
    clearOnDemandCache,
    createMediumBooking,
    createOnDemandBooking,
    getMediumOndemandEvents,
    getZoomLinkOnDemand,
    rejectOnDemandSession,
    removeMediumFromOnDemandQueue,
    removePairFromCache,
    updateOnDemandBoxStatus,
    mediumInfo,
    createGroupSessionPaidBooking,
    getPastSpeakerEvent,
    getZoomLinkAppt
} from "../../../services/medium";
import AlredyJoined from "./alreadyJoined";
import ConfirmOut from "./confirmOut";
import { el } from "date-fns/locale";
import Pusher from "pusher-js";
import ReminderPopUp from "./reminderPopup";
import ExitQueuePopup from "./exitQueuePopup";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import CountdownTimerReact from "./countdown";
import { getTimeImage } from "../../../utils/utils";
import { setLoadingContent, setLoadingText } from "../../../reducer/auth/auth";
import TimeEndedPopup from "./timeendedpopup";
import TimerForEvent from "./timerforevent";
import ChooseMedium from "./choosemedium";
import { toast } from "react-toastify";
import PartnerEndedPopup from "./partnerendedpopup";
import EmerGencyPopUp from "./emergencypopup";
import { setIsOnDemandBox, setUser } from "../../../reducer/userSlice";
import CacheStep from "./cacheStep";
import { getBrowserData } from "../../../utils/helpers";
import { fetchUser } from "../../../services/auth";
import { items } from "../../admin/calendar/data";
import BookAppointmentPopUp from "./bookappointmentpopup";
import QuestionPopUp from "./questions";
import BookingConfirmPopUp from "./bookingconfirmpopup";
import BookingConfirm from "../../medium/booking/confirm";
import { getOndemandCategories } from "../../../services/admin";
import { ClockLoader, GridLoader } from "react-spinners";
import LoaderText from "../../../components/loader";
import PayItForwardPopUp from "../../client/appointments/components/payitforward";
import PayOptionsPopUp from "../../medium/booking/componetnts/paymentoptions";
import { getAllTopic } from "../../../services/admin";
import { getSpecialEventLanguageLabel } from "./eventDisplay";
import { useTranslation, Trans } from "react-i18next";
import { useDynamicTranslation } from "../../../i18n/dynamicContent";

import AllImg from "./images/all.png";
import CommunityImg from "./images/community.png";
import GroupImg from "./images/group.png";
import onDemandImg from "./images/on-demand.png";
import PracticeImg from "./images/practice.png";
import Speaker from "./images/speaker.png";

export default function GoOnDemandPractice1({ setSessions, sessions, session_id, setsession_id, eventType,
        seteventType, role }) {
    const { t } = useTranslation("clientOnDemand");
    // Text from the API (titles, sub texts, session types, topics, levels) and dates.
    const { tc, tLanguage, tSpots, formatDate } = useDynamicTranslation();
    const dayLabel = (item) => formatDate(item.dateInfo, { weekday: "short" }, item.day);
    const monthLabel = (item) => formatDate(item.dateInfo, { month: "short" }, item.monthname);
    const {
        timezone,
        id,
        is_on_demand_box,
        cache_clear_confirmations,
        timezone_name,
        test_mode,

    } = useSelector((state) => state.user.user);
    const [searchParams] = useSearchParams();
    const comingFrom = searchParams.get("to");
     const cleanupRef = useRef(null);
    const [newTopic, setNewTopic] = useState([]);

    const dispatch = useDispatch();

    const currentUserTime = moment()

        .tz(timezone_name)
        .format("hh:mm A");
    const currentUserDate = moment()
        .tz(timezone_name)
        .format("hh:mm A");
    const [loaderType, setloaderType] = useState("1");
    const [inputValue, setInputValue] = useState("");
    const [info, setInfo] = useState();
    const [Index, setIndex] = useState(0);
    const [eventsList, setEventList] = useState([]);
    const [visibleCount, setVisibleCount] = useState(1000);
    const [values, setValues] = useState([]);
    const [fromTime, setFromTime] = useState("");
    const [toTime, setToTime] = useState("");
    const [timer, setTimer] = useState(null);
    const [activeEvent, setActiveEvent] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [time, setTime] = useState(0);

    const [ondemandStatus, setOndamandStatus] = useState(false);
    const [counterStatus, setCounterStatus] = useState(false);
    const [shoHostStatus, setshoHostStatus] = useState(false);
    const [meeting_link, setmettingLink] = useState("");
    const [meetingLinkStatus, setmettingLinkStatus] = useState(false);
    const [appoinmentId, setAppoinmentId] = useState("");
    const [mediumValue, setMediumValue] = useState("");
    const [bookedItemIds, setBookedItemIds] = useState([]);

    //new
    const [pairedUsers, setPairedUsers] = useState([]);
    const [pairedevent_id, setpairedevent_id] = useState("");
    const [runagain, setRunAgain] = useState(false);
    const [hangon, setHangOn] = useState(false);
    const [acceptSession, seAcceptSession] = useState(false);
    const [otherInfo, setOtherInfo] = useState();
    const [seconds, setSeconds] = useState(30);
    const [isActivePaired, setIsActivePaired] = useState(false);
    const [checkYes, setCheckYes] = useState(false);
    const [matchName, setMatchName] = useState("");
    const [message, setMessage] = useState("");
    const [timeLeft, setTimeLeft] = useState(""); // 10 minutes in seconds (600 seconds)
    const [isActive, setIsActive] = useState(false);
    const [is_verified, setIs_verified] = useState(false);
    const [checkONdemandMessage, setcheckONdemandMessage] = useState("");
    const [directAppMediumName, setdirectAppMediumName] = useState("");
    const [directAppMediumInfo, setdirectAppMediumInfo] = useState({});
    const [slotDetails, setslotDetails] = useState({});
    const [userDetails, setuserDetails] = useState({});
    // const [sessions, setSessions] = useState([]);
    // const [session_id, setsession_id] = useState('');
    const [disabledfilters, setDisabledFilters] = useState(false);
    const [disableLoadMore, setdisableLoadMore] = useState(false);
    const [activePay, setActivePay] = useState("");
    const [payItforwardValue, setpayItforwardValue] = useState('');
    const [payItforwardFixPrice, setpayItforwardFixPrice] = useState("")
    const [paymentCurrency, setPaymentCurrency] = useState('USD');
    const [paymentstatus, setPaymentstatus] = useState(false);
    const [body, setBody] = useState({});
    const [topicstate, setTopicState] = useState(false);
    const [topicValue, setTopicValue] = useState('')
    const [showTabs, setShowTabs] = useState(true);
    const [isSoundManuallyStopped, setIsSoundManuallyStopped] = useState(false);
    const [checked, setChecked] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isWorker, setIsWorker] = useState(0);
    const [isBookingInProgress, setIsBookingInProgress] = useState(false);
    const [showCommunityRefreshRetry, setShowCommunityRefreshRetry] = useState(false);
     const [sessionId, setSessionId] = useState('');
      const [url, setUrl] = useState(1);
      const [yturl, setYtUrl] = useState("")

    const mapOnDemandEvents = (events = []) => {
        return events.map((info) => {
            return {
                id: info.id,
                description: info.description,
                ondemand_session_category_id: info.ondemand_session_category_id,
                name: info.title,
                time: info.start_time,
                monthname: month(info.date),
                date: date(info.date),
                dateInfo: info.date,
                day: day(info.date),
                fullday: fullday(info.date),
                subtext: info.sub_text,
                backupdate: info.date,
                end_time: info.end_time,
                is_event_started: info.is_event_started,
                spots_left: info.spots_left !== undefined ? info.spots_left : "",
                is_group_event:
                    info.is_group_event !== undefined ? info.is_group_event : false,
                session_id: info.session_id !== undefined ? info.session_id : "",
                medium_name: info.medium_name !== undefined ? info.medium_name : "",
                medium_id: info.medium_id !== undefined ? info.medium_id : "",
                duration: info.duration !== undefined ? info.duration : "",
                title: info.title,
                currency: info.currency !== undefined ? info.currency : "USD",
                button_status: info.button_status !== undefined ? info.button_status : "0",
                is_booked: info.is_booked !== undefined ? info.is_booked : "0",
                price_for_attendees: info.price_for_attendees !== undefined ? info.price_for_attendees : null,
                topic: info.topic !== undefined ? info.topic : '',
                medium_availability_id: info.medium_availability_id !== undefined ? info.medium_availability_id : '',
                language: info.language !== undefined ? info.language : '',
                is_worker_event: info.is_worker_event !== undefined ? info.is_worker_event : 0,
                total_workers_required: info.total_workers_required !== undefined ? info.total_workers_required : 0,
                workers_positions_left: info.workers_positions_left !== undefined ? info.workers_positions_left : 0,
                total_spots_left: info.total_spots_left !== undefined ? info.total_spots_left : 0,
                zoom_link: info.zoom_link !== undefined ? info.zoom_link : ''
            };
        });
    };

    const isCommunitySupportBooking = (eventInfo = directAppMediumInfo) => {
        const categoryId =
            eventInfo && eventInfo.ondemand_session_category_id !== undefined
                ? eventInfo.ondemand_session_category_id
                : "";

        return String(categoryId) === "96";
    };

    const refreshCommunityEventsAfterBooking = async () => {
        const from = fromTime || moment().format("YYYY-MM-DD");
        let to = toTime;
        if (!to) {
            to = moment(from, "YYYY-MM-DD").add(15, "days").format("YYYY-MM-DD");
        }

        const topicFilter = String(session_id) === "96" ? topicValue : "";
        setEventList([]);
        window.eventsList = [];
        setBookedItemIds([]);

        const data = await getMediumOndemandEvents(from, to, inputValue, session_id, topicFilter);
        const responseData = data && data.data && data.data.data ? data.data.data : {};
        const events = Object.values(responseData).flat();
        const newEvents = mapOnDemandEvents(events);

        setEventList(newEvents);
        window.eventsList = newEvents;
        setShowCommunityRefreshRetry(false);
    };

    const retryCommunityRefresh = async () => {
        if (isBookingInProgress) return;
        setIsBookingInProgress(true);
        dispatch(setLoadingContent(`<div>${t("loading.pleaseWait")}</div>`));
        dispatch(setLoadingText(true));
        try {
            await refreshCommunityEventsAfterBooking();
        } catch (err) {
            toast.warning(t("toasts.refreshFailed"), {
                position: "top-center",
            });
            setShowCommunityRefreshRetry(true);
        } finally {
            dispatch(setLoadingContent(``));
            dispatch(setLoadingText(false));
            setIsBookingInProgress(false);
        }
    };

      const openModalHandler = (item, link = "") => {
    setYtUrl(link);
    setUrl(item);
    setOpenModal(!openModal);
  };
  useEffect(() => {
      if (openModal) {
        window.loadModal2("#3-year-video", "show");
      } else {
        window.loadModal2("#3-year-video", "hide");
      }
    }, [openModal]);
    //new
    let interval;

    useEffect(() => {
        // getOndemandCategories().then((data) => {
        //     // if (data.data.status) {
        //     console.log(data.data.data);
        //     let array = data.data.data
        //     const newObject = { id: 0, sub_session_name: 'All Practice Circles' }
        //     array.splice(1, 0, newObject);
        //     setSessions(array)
        //     console.log(array, "array");
        //     // }
        // })
        setSessionId(session_id);
        if(eventType =="Upcoming"){
            setChecked(false)
        }else{
            setChecked(true)
        }
        console.log(session_id, "session_id",eventType ,"eventType");

        getAllTopic()
            .then((data) => {
                setNewTopic(data.data.data);
                console.log(data.data.data, "topics");
            })
            .catch((err) => console.log(err));

        if (session_id == 96) {
            setTopicState(true)
        } else {
            setTopicState(false)
        }
    }, [])

    const resetEvents = () => {
        setValues([])
        setTopicValue('');
        setTopicState(false)
        setInputValue('')

        const from = moment().format("YYYY-MM-DD");
        const to = moment()
            .add(15, "days")
            .format("YYYY-MM-DD");
        setFromTime(from);

        setToTime(to);

        getEventList(from, to, '', session_id);
    }
    const audioRef = useRef(null);

    const playMatchSound = () => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = 0.2;
        audio.loop = true;
        audio.play().catch((err) => {
            console.warn("Autoplay blocked:", err);
        });
    };

    const stopMatchSound = () => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.pause();
        audio.currentTime = 0;
    };

    const primeMatchSound = () => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = 0.2;
        audio.play()
            .then(() => {
                audio.pause();
                audio.currentTime = 0;
            })
            .catch(() => {
                // Ignore if browser still blocks; regular play is attempted on match.
            });
    };

   useEffect(() => {
    const audio = audioRef.current;

    if (!audio) return;
console.log(loaderType, "loaderType");
        if (loaderType == 5 ) {
            playMatchSound();
    } else {
            stopMatchSound();
    }

    // Optional cleanup on unmount
    return () => {
            stopMatchSound();
    };
  }, [loaderType]);
  const handleStopSound = () => {
    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }

  };
    const loadMoreItems = () => {
        seteventType("Upcoming");
        setChecked(false);
        dispatch(setLoadingContent(`<div>${t("loading.pleaseWait")}</div>`));
        dispatch(setLoadingText(true));
        // if (eventsList.length > visibleCount) {
        //     setVisibleCount((prevCount) => prevCount + 5);
        //     setFromTime(fromTime);
        //     setToTime(toTime);
        // }
        //  else {
        console.log(values, session_id)
        if (!values.length && session_id == "") {

            const from = moment(toTime, "YYYY-MM-DD")
                .add(1, "days")
                .format("YYYY-MM-DD");
            const to = moment(from, "YYYY-MM-DD")
                .add(15, "days")
                .format("YYYY-MM-DD");
            setFromTime(from);
            setToTime(to);
            getMediumOndemandEvents(from, to, inputValue, session_id)
                .then((data) => {
                    dispatch(setLoadingContent(""));
                    dispatch(setLoadingText(false));
                    const events = Object.values(data.data.data).flat();

                    let newEvents = events.map((info) => {
                        return {
                            id: info.id,
                            description: info.description,
                            ondemand_session_category_id: info.ondemand_session_category_id,
                            name: info.title,
                            // time: times(info.start_time),
                            time: info.start_time,
                            monthname: month(info.date),
                            date: date(info.date),
                            dateInfo: info.date,
                            day: day(info.date),
                            fullday: fullday(info.date),
                            subtext: info.sub_text,
                            backupdate: info.date,
                            end_time: info.end_time,
                            // showReminder: checkTime(info.date, info.start_time, info.end_time),
                            is_event_started: info.is_event_started,
                            spots_left: info.spots_left !== undefined ? info.spots_left : "",
                            is_group_event:
                                info.is_group_event !== undefined ? info.is_group_event : false,
                            session_id: info.session_id !== undefined ? info.session_id : "",
                            medium_name:
                                info.medium_name !== undefined ? info.medium_name : "",
                            medium_id: info.medium_id !== undefined ? info.medium_id : "",
                            duration: info.duration !== undefined ? info.duration : "",
                            title: info.title,
                            currency: info.currency !== undefined ? info.currency : "USD",
                            button_status: info.button_status !== undefined ? info.button_status : "0",
                            is_booked: info.is_booked !== undefined ? info.is_booked : "0",
                            price_for_attendees: info.price_for_attendees !== undefined ? info.price_for_attendees : null,
                            topic: info.topic !== undefined ? info.topic : '',
                            medium_availability_id: info.medium_availability_id !== undefined ? info.medium_availability_id : '',
                            language: info.language !== undefined ? info.language : '',
                            practice_circle_level_label: info.practice_circle_level_label !== undefined ? info.practice_circle_level_label : '',
                            is_worker_event: info.is_worker_event !== undefined ? info.is_worker_event : 0,
                            total_workers_required: info.total_workers_required !== undefined ? info.total_workers_required : 0,
                            workers_positions_left: info.workers_positions_left !== undefined ? info.workers_positions_left : 0,
                            total_spots_left: info.total_spots_left !== undefined ? info.total_spots_left : 0,
                        zoom_link: !!info.zoom_link,
                        appointment_id: info.appointment_id ? info.appointment_id : null
                        };
                    });
                    let newE = eventsList;
                    let newarray = newE.concat(newEvents);
                    console.log("eventsList", eventsList, "newEvents", newEvents);
                    setEventList(newarray);
                    console.log(newarray, "");
                    // runIntervalFunc(newEvents);
                    setVisibleCount((prevCount) => prevCount + 5);
                })
                .catch(() => {
                    dispatch(setLoadingContent(""));
                    dispatch(setLoadingText(false));
                });
        }
        else if (session_id != "" && !values.length) {
            console.log(values, session_id, "values,");
            let to;
            const from = moment(toTime, "YYYY-MM-DD")
                        .add(1, "days")
                        .format("YYYY-MM-DD");

            if (session_id == "95") {
                to = moment(from, "YYYY-MM-DD")
                    .add(60, "days")
                    .format("YYYY-MM-DD");
            } else if (session_id == "101") {
                to = moment(from, "YYYY-MM-DD")
                    .add(90, "days")
                    .format("YYYY-MM-DD");
            }else if(session_id == "91"){
                to = moment(from, "YYYY-MM-DD")
                    .add(0, "days")
                    .format("YYYY-MM-DD");
            } else {
                to = moment(from, "YYYY-MM-DD")
                    .add(15, "days")
                    .format("YYYY-MM-DD");
            }

            setFromTime(from);
            setToTime(to);
            getMediumOndemandEvents(from, to, inputValue, session_id)
                .then((data) => {
                    dispatch(setLoadingContent(""));
                    dispatch(setLoadingText(false));
                    const events = Object.values(data.data.data).flat();
                    if (Array.isArray(data.data.data) && data.data.data.length === 0) {
                                    setdisableLoadMore(true);
                        }
                    console.log(events, "events", data.data.data, "data.data.data");

                    let newEvents = events.map((info) => {
                        return {
                            id: info.id,
                            description: info.description,
                            ondemand_session_category_id: info.ondemand_session_category_id,
                            name: info.title,
                            // time: times(info.start_time),
                            time: info.start_time,
                            monthname: month(info.date),
                            date: date(info.date),
                            dateInfo: info.date,
                            day: day(info.date),
                            fullday: fullday(info.date),
                            subtext: info.sub_text,
                            backupdate: info.date,
                            end_time: info.end_time,
                            // showReminder: checkTime(info.date, info.start_time, info.end_time),
                            is_event_started: info.is_event_started,
                            spots_left: info.spots_left !== undefined ? info.spots_left : "",
                            is_group_event:
                                info.is_group_event !== undefined ? info.is_group_event : false,
                            session_id: info.session_id !== undefined ? info.session_id : "",
                            medium_name:
                                info.medium_name !== undefined ? info.medium_name : "",
                            medium_id: info.medium_id !== undefined ? info.medium_id : "",
                            duration: info.duration !== undefined ? info.duration : "",
                            title: info.title,
                            currency: info.currency !== undefined ? info.currency : "USD",
                            button_status: info.button_status !== undefined ? info.button_status : "0",
                            is_booked: info.is_booked !== undefined ? info.is_booked : "0",
                            price_for_attendees: info.price_for_attendees !== undefined ? info.price_for_attendees : null,
                            topic: info.topic !== undefined ? info.topic : '',
                            medium_availability_id: info.medium_availability_id !== undefined ? info.medium_availability_id : '',
                            language: info.language !== undefined ? info.language : '',
                            practice_circle_level_label: info.practice_circle_level_label !== undefined ? info.practice_circle_level_label : '',
                            is_worker_event: info.is_worker_event !== undefined ? info.is_worker_event : 0,
                            total_workers_required: info.total_workers_required !== undefined ? info.total_workers_required : 0,
                            workers_positions_left: info.workers_positions_left !== undefined ? info.workers_positions_left : 0,
                            total_spots_left: info.total_spots_left !== undefined ? info.total_spots_left : 0,
                        zoom_link: !!info.zoom_link,
                        appointment_id: info.appointment_id ? info.appointment_id : null
                        };
                    });
                    let newE = eventsList;
                    let newarray = newE.concat(newEvents);
                    console.log("eventsList", eventsList, "newEvents", newEvents);
                    setEventList(newarray);
                    console.log(newarray, "");
                    // runIntervalFunc(newEvents);
                    setVisibleCount((prevCount) => prevCount + 5);
                })
                .catch(() => {
                    dispatch(setLoadingContent(""));
                    dispatch(setLoadingText(false));
                });
        }
        else {
            setdisableLoadMore(true);
        }
        // }
    };

    const navigate = useNavigate();
console.log(session_id, "session_id");
    const day = (day) => moment(day).format("ddd"); // Short day name (e.g., 'Fri')
    const fullday = (day) => moment(day).format("dddd");
    const month = (month) => moment(month).format("MMM"); // Short month name (e.g., 'Sep')
    const date = (date) => moment(date).format("DD");
    const times = (time) => moment(time, "HH:mm").format("hh:mm A");
    const location = useLocation();

    // useEffect(() => {
    //   const handleRouteChange = () => {
    //     console.log("Route changed!");
    //     removeMediumFromQueue()
    //   };

    //   handleRouteChange(); // Initial call on component mount

    //   // Return cleanup function if needed (not necessary for route changes here)
    // }, [location]);
    // past speaker event

    const pastSpeakerEvent = () => {
        setDisabledFilters(true)
            getPastSpeakerEvent()
            .then((data) => {

                setdisableLoadMore(false)
                const events = Object.values(data.data.data);
                let newEvents = events.map((info) => {
                    return {
                        id: info.id,
                        description: "",
                        ondemand_session_category_id: info.ondemand_session_category_id,
                        name: info.title,
                        video: info.video_link,
                        // time: times(info.start_time),
                        time: info.start_time,
                        monthname: month(info.date),
                        date: date(info.date),
                        dateInfo: info.date,
                        day: day(info.date),
                        fullday: fullday(info.date),
                        subtext: "",
                        backupdate: info.date,
                        end_time: info.end_time,
                        // showReminder: checkTime(info.date, info.start_time, info.end_time),
                        is_event_started: "",
                        spots_left: info.spots_left !== undefined ? info.spots_left : "",
                        is_group_event:
                            info.is_group_event !== undefined ? info.is_group_event : false,
                        session_id: info.session_id !== undefined ? info.session_id : "",
                        medium_name: info.medium_name !== undefined ? info.medium_name : "",
                        medium_id: info.medium_id !== undefined ? info.medium_id : "",
                        duration: info.duration !== undefined ? info.duration : "",
                        title: info.title,
                        currency: info.currency !== undefined ? info.currency : "USD",
                        button_status: info.button_status !== undefined ? info.button_status : "0",
                        is_booked: info.is_booked !== undefined ? info.is_booked : "0",
                        price_for_attendees: info.price_for_attendees !== undefined ? info.price_for_attendees : null,
                        topic: info.topic !== undefined ? info.topic : '',
                        medium_availability_id: info.medium_availability_id !== undefined ? info.medium_availability_id : '',
                        language: info.language !== undefined ? info.language : '',
                        practice_circle_level_label: info.practice_circle_level_label !== undefined ? info.practice_circle_level_label : '',
                        is_worker_event: info.is_worker_event !== undefined ? info.is_worker_event : 0,
                        total_workers_required: info.total_workers_required !== undefined ? info.total_workers_required : 0,
                        workers_positions_left: info.workers_positions_left !== undefined ? info.workers_positions_left : 0,
                        total_spots_left: info.total_spots_left !== undefined ? info.total_spots_left : 0,
                        zoom_link: !!info.zoom_link,
                        appointment_id: info.appointment_id ? info.appointment_id : null
                    };
                });

                    setDisabledFilters(false);


                console.log(newEvents, "newEvents");
                setEventList(newEvents);

                window.eventsList = newEvents
                // runIntervalFunc(newEvents);
            })
            .catch(() => { });
    }

    //functions
    const getEventList = (from, to, keyword, session_id, topic_val, type,typeCheck="") => {
        console.log(session_id, "session_id",eventType,"eventType","test")
        if(session_id == 95 && eventType == "Past" && typeCheck==""){
            pastSpeakerEvent();
            return;
        }
        if(session_id == 91){
            to = moment(from, "YYYY-MM-DD")
                    .add(0, "days")
                    .format("YYYY-MM-DD");
            setToTime(to);
        }
        console.log("to Time: ". to);

        setVisibleCount(15);
        setDisabledFilters(true)
        setdisableLoadMore(false);

        getMediumOndemandEvents(from, to, keyword, session_id, topic_val)
            .then((data) => {

                console.log(disableLoadMore, "disableLoadMore")
                if (type === "disable") {
                    setdisableLoadMore(true)

                }
                const events = Object.values(data.data.data).flat();
                console.log(events, "events", data.data.data, "data.data.data");

                let newEvents = events.map((info) => {
                    return {
                        id: info.id,
                        description: info.description,
                        ondemand_session_category_id: info.ondemand_session_category_id,
                        name: info.title,
                        // time: times(info.start_time),
                        time: info.start_time,
                        monthname: month(info.date),
                        date: date(info.date),
                        dateInfo: info.date,
                        day: day(info.date),
                        fullday: fullday(info.date),
                        subtext: info.sub_text,
                        backupdate: info.date,
                        end_time: info.end_time,
                        // showReminder: checkTime(info.date, info.start_time, info.end_time),
                        is_event_started: info.is_event_started,
                        spots_left: info.spots_left !== undefined ? info.spots_left : "",
                        is_group_event:
                            info.is_group_event !== undefined ? info.is_group_event : false,
                        session_id: info.session_id !== undefined ? info.session_id : "",
                        medium_name: info.medium_name !== undefined ? info.medium_name : "",
                        medium_id: info.medium_id !== undefined ? info.medium_id : "",
                        duration: info.duration !== undefined ? info.duration : "",
                        title: info.title,
                        currency: info.currency !== undefined ? info.currency : "USD",
                        button_status: info.button_status !== undefined ? info.button_status : "0",
                        is_booked: info.is_booked !== undefined ? info.is_booked : "0",
                        price_for_attendees: info.price_for_attendees !== undefined ? info.price_for_attendees : null,
                        topic: info.topic !== undefined ? info.topic : '',
                        medium_availability_id: info.medium_availability_id !== undefined ? info.medium_availability_id : '',
                        language: info.language !== undefined ? info.language : '',
                        practice_circle_level_label: info.practice_circle_level_label !== undefined ? info.practice_circle_level_label : '',
                        is_worker_event: info.is_worker_event !== undefined ? info.is_worker_event : 0,
                        total_workers_required: info.total_workers_required !== undefined ? info.total_workers_required : 0,
                        workers_positions_left: info.workers_positions_left !== undefined ? info.workers_positions_left : 0,
                        total_spots_left: info.total_spots_left !== undefined ? info.total_spots_left : 0,
                        zoom_link: !!info.zoom_link,
                        appointment_id: info.appointment_id ? info.appointment_id : null
                    };
                });

                console.log(newEvents, "newEvents");
                setEventList(newEvents);
                setTimeout(() => {
                    setDisabledFilters(false);
                }, 1000);

                window.eventsList = newEvents
                // runIntervalFunc(newEvents);
            })
            .catch(() => { });
    };

    const checkOldTime = (datee, timee) => {
        let status = false;
        // moment(`${datee} ${timee}`, "YYYY-MM-DD hh:mm A").tz(timezone_name)
        // const targetDate =  moment(`${datee} ${timee}`, "YYYY-MM-DD hh:mm A");
        const targetDate = moment(`${datee} ${timee}`, "YYYY-MM-DD hh:mm A").tz(
            timezone_name
        );
        const currentDate = moment("YYYY-MM-DD hh:mm A").tz(timezone_name);

        // Check if the current time is past the target time
        // console.log(currentDate.isSame(targetDate), "currentDate.isSame(targetDate)")
        if (currentDate.isSame(targetDate)) {
            status = true;
        } else {
            status = false;
        }
        return status;
    };
    const checkEndTime = (item) => {
        let status = true;
        let currenTime = moment().format("YYYY-MM-DD hh:mm A");

        let eventtime = moment(
            `${item.backupdate} ${item.end_time}`,
            "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DD hh:mm A");

        // let beforeTime = moment(eventtime).subtract(15, 'minutes');
        const differenceInMinutes = moment(eventtime.replace(/-/g, "/")).diff(
            currenTime.replace(/-/g, "/"),
            "seconds"
        );
        return differenceInMinutes;

        // return differenceInMinutes;
    };
    const expireSession = (item) => {
        // checkEndTime(item);
        if (checkEndTime(item) == 0) {
            clearOnDemandCache(item.id).then(() => { });
        }
        // clearOnDemandCache()
    };
    const runIntervalFunc = (event = []) => {
        let checkReturnItem;
        interval = setInterval(() => {
            let list = eventsList.length > 0 ? eventsList : event;
            let newlist = list.filter((item) => {
                expireSession(item);
                checkReturnItem = checkOldTime(item.backupdate, item.end_time);
                // console.log(checkReturnItem, "checkReturnItem value passed")
                if (!checkOldTime(item.backupdate, item.end_time)) {
                    return item;
                }
            });
            console.log(newlist, "newlist");
            let newEvent = newlist.map((item) => {
                // console.log(item.backupdate, item.time);
                let status = checkTime(item.backupdate, item.time, item.end_time);
                return {
                    ...item,
                    showReminder: status,
                }; // Example: Incrementing each value
            });
            // console.log(newEvent, "newEvent")
            console.log(checkReturnItem, "checkReturnItem value passed");
            if (checkReturnItem) {
                localStorage.setItem("run", "yes");
                if (!localStorage.getItem("run")) {
                    // console.log(checkReturnItem, "checkReturnItem")
                    const from = moment().format("YYYY-MM-DD");
                    const to = moment()
                        .add(1, "days")
                        .format("YYYY-MM-DD");
                    setFromTime(from);
                    setToTime(to);

                    getEventList(from, to, "");
                    return;
                }
            } else {
                localStorage.removeItem("run");
            }
            setEventList(newEvent);
        }, 6000); // 60 seconds = 60000 ms
        // Cleanup the interval on component unmount
        return () => clearInterval(interval);
    };
    const getClientProfileDetails = (item, index) => {
        setIndex(index);
        setInfo(item);
        window.loadModal2("#ScheduledetailsModal", "show");
    };
    const handleValueChange = (newValues) => {
        seteventType('Upcoming')
        setChecked(false);

        if (newValues) {
            let topicData = '';
            if (session_id == "96") {
                topicData = topicValue;
            }
            setValues(newValues);
            let name = {};
            if (newValues.length === 2) {
                const startDate = newValues[0].format("YYYY-MM-DD");
                const endDate = newValues[1].format("YYYY-MM-DD");
                // name["created_at"] = `${startDate},${endDate}`; // Fix the assignment
                setFromTime(startDate);
                setToTime(endDate);
                getEventList(startDate, endDate, inputValue, session_id, topicData, 'disable');
            }
            // if(newValues.length === 1){
            //   console.log( newValues[0].format("YYYY-MM-DD"))
            //   const startDate = newValues[0].format("YYYY-MM-DD");
            //   getEventList('', '','',startDate)
            // }
        }
    };
    const inputChanged = (e) => {
        seteventType('Upcoming')
        setChecked(false);
        let value = e.target.value;
        setInputValue(e.target.value);
        let topicData = '';
        if (session_id == "96") {
            topicData = topicValue;
        }
        clearTimeout(timer);
        console.log(e.target.value.length, "e.target.value.length", session_id,"test")
        let to;
        if (session_id == "95") {
            to = moment().add(60, "days").format("YYYY-MM-DD");
        } else if (session_id == "101") {
            to = moment().add(90, "days").format("YYYY-MM-DD");
        }else {
            to = moment().add(15, "days").format("YYYY-MM-DD");
        }
        const newTimer = setTimeout(() => {
            if (e.target.value.length > 2) {
                const from = moment().format("YYYY-MM-DD");
                //  to = moment()
                //     .add(15, "days")
                //     .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                getEventList(from, to, value, session_id, topicData);
            }
            else if (e.target.value.length == 0) {
                console.log('this also runi');
                const from = moment().format("YYYY-MM-DD");
                //  to = moment()
                //     .add(15, "days")
                //     .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                getEventList(from, to, value, session_id, topicData);
            }
            else {

            }

        }, 2000);

        setTimer(newTimer);
    };
    const checkTime = (date, time, end) => {
        const dateToCheck = moment(date).tz(timezone_name); // Replace with the date you want to check
        const isToday = dateToCheck.isSame(moment().tz(timezone_name), "day");
        console.log(isToday, "isToday");
        // console.log(isToday, date)

        if (isToday) {
            // Convert input to moment
            let currentTime = moment()
                .format("YYYY-MM-DD HH:mm")
                .tz(timezone_name);
            let endtime = moment(`${date} ${end}`, "YYYY-MM-DD hh:mm A")
                .format("YYYY-MM-DD HH:mm")
                .tz(timezone_name);

            const inputMoment = moment(`${date} ${time}`, "YYYY-MM-DD hh:mm A")
                .tz(timezone_name)
                .format("YYYY-MM-DD HH:mm");
            const time1 = moment(currentTime, "YYYY-MM-DD HH:mm").tz(timezone_name);
            const time2 = moment(inputMoment, "YYYY-MM-DD HH:mm").tz(timezone_name);

            const time3 = moment(endtime.replace(/-/g, "/"), "YYYY-MM-DD HH:mm").tz(
                timezone_name
            );
            const minutes = time3.diff(time1, "minutes");
            const minutesDifference = time1.diff(time2, "minutes");
            let status = minutesDifference >= 0 && minutes > 0;

            return status;
        } else {
            return isToday;
        }
        return;

        // Check if the difference is between 0 and 10 (inclusive) or exactly 0
    };
    const openReminderPopup = (info) => {
        localStorage.setItem("activeEvent", info.id);
        setActiveEvent(info);
        window.loadModal2("#ReminderPopUp", "show");
    };
    const cacheCheck = (info) => {
        setActiveEvent(info);
        localStorage.setItem("activeEvent", info.id);
        localStorage.setItem("ondemandLoader", "2");
        localStorage.removeItem("matched");
        if (is_verified) {
            setloaderType("7");
        } else {
            setloaderType("2");
        }
    };
    const callProfile = async () => {
        await fetchUser()
            .then((data) => {
                dispatch(setUser(data.data.data));
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const startLoaderOndemand = (type) => {
        closePopup(type);
    };
    const checkMediumInOnDemand = (info, check, user_pereference) => {
        dispatch(setLoadingContent(`<div>${t("loading.pleaseWait")}</div>`));
        dispatch(setLoadingText(true));
        setTime(0);

        setOndamandStatus(false);
        checkMediumInOnDemandQueue()
            .then((data) => {
                console.log(data.data.data.in_queue, "data");
                console.log(data.data.data.is_cache_cleared, "data");
                dispatch(setLoadingContent(""));
                dispatch(setLoadingText(false));
                setActiveEvent(info);
                localStorage.setItem("activeEvent", info.id);
                localStorage.setItem("ondemandLoader", "2");
                localStorage.removeItem("matched");
                setcheckONdemandMessage(data.data.success);
                if (data.data.data.in_queue) {
                    window.loadModal2("#AlredyJoined", "show");
                } else if (
                    !data.data.data.in_queue &&
                    !data.data.data.is_cache_cleared
                ) {
                    setloaderType("2");
                } else if (
                    !data.data.data.in_queue &&
                    data.data.data.is_cache_cleared
                ) {
                    setloaderType("7");
                }
            })
            .catch(() => {
                checkMediumInOnDemand(info, check, user_pereference);
            });
    };

    const addMediumQueue = (check) => {
        setRunAgain(false);
        dispatch(setLoadingContent(`<div>${t("loading.pleaseWait")}</div>`));
        dispatch(setLoadingText(true));
        console.log(activeEvent, "activeEvent");
        let event_id = activeEvent.id;
        let date = activeEvent.backupdate;
        let end_time = activeEvent.end_time;
        let user_pereference = check == "yes" ? 0 : 1;

        // setTimeout(() => {

        addMediumToOnDemandQueue(event_id, date, end_time, user_pereference)
            .then((data) => {
                console.log(data.data);
                dispatch(setLoadingContent(""));
                dispatch(setLoadingText(false));
                setHangOn(false);
                setIsActivePaired(false);
                setSeconds(30);
                if (data.data.data) {
                    let matched = localStorage.getItem("matched");
                    if (matched) {
                        return;
                    }
                    checkTimes();
                }
            })
            .catch(() => {
                // addMediumQueue(check)
            });
        // }, 5000);
    };

    const removeMediumFromQueue = () => {
        let ids = JSON.parse(localStorage.getItem("activeEvent"));
        if (ids) {
            removeMediumFromOnDemandQueue(ids)
                .then((data) => {
                    console.log(data);

                    if (data.data.data) {
                        setTime(0);
                        setOndamandStatus(true);
                        setTimeout(() => {
                            setloaderType("1");
                            dispatch(setLoadingContent(""));
                            dispatch(setLoadingText(false));
                            localStorage.removeItem("activeEvent");
                        }, 1000);
                    } else {
                        dispatch(setLoadingContent(""));
                        dispatch(setLoadingText(false));
                        // toast.error("There is problem while Removing you", { position: "top-center" })
                    }
                })
                .catch(() => {
                    removeMediumFromQueue();
                    dispatch(setLoadingContent(""));
                    dispatch(setLoadingText(false));
                });
        }
    };
    const startLoaderNow = (user_pereference) => {
        // Prime audio from a direct user action so match sound can play reliably.
        primeMatchSound();
        addMediumQueue(user_pereference);
        setTime(0);
    };

    const getZoomLink = (id) => {
        let status = true;
        getZoomLinkOnDemand(id)
            .then((data) => {
                // if (status) {
                if (!data.data.data) {
                    setTimeout(() => {
                        getZoomLink(appoinmentId);
                    }, 5000);
                } else if (data.data.success == "Appointment Zoom Link") {
                    setmettingLink(data.data.data);
                    setTimeout(() => {
                        navigate("/appointments?from=goondemand");
                    }, 300000);
                }
            })
            .catch((er) => {
                console.log(er);
            });
    };
    const hideCountdownTimer = () => {
        setCounterStatus(false);
    };

    const fifteenMinutesBefore = (item) => {
        let status = true;
        let currenTime = moment()
            .tz(timezone_name)
            .format("YYYY-MM-DD hh:mm A");

        let eventtime = moment(
            `${item.backupdate} ${item.time}`,
            "YYYY-MM-DD hh:mm A"
        )
            .tz(timezone_name)
            .format("YYYY-MM-DD hh:mm A");

        let beforeTime = moment(eventtime)
            .subtract(15, "minutes")
            .tz(timezone_name);
        const differenceInMinutes = moment(eventtime.replace(/-/g, "/")).diff(
            currenTime.replace(/-/g, "/"),
            "minutes"
        );
        if (differenceInMinutes > 0 && differenceInMinutes < 16) {
            status = false;
        } else {
            status = true;
        }
        return status;
    };
    const backHandler = () => {
        dispatch(
            setLoadingContent(
                `<div>${t("loading.removingFromQueue")}</div>`
            )
        );
        dispatch(setLoadingText(true));

        let matched = localStorage.getItem("matched");
        if (!matched) {
            removeMediumFromQueue();
        }
    };

    const checkTimes = () => {
        let status = true;
        let currenTime = moment()
            .tz(timezone_name)
            .format("YYYY-MM-DD hh:mm A");
        console.log(currenTime, "currenTime");
        let eventtime = moment(
            `${activeEvent.backupdate} ${activeEvent.end_time}`,
            "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DD hh:mm A");
        // console.log(eventtime,"eventtime" ,moment(eventtime).tz(timezone_name).format('YYYY-MM-DD hh:mm A'))
        // let beforeTime = moment(eventtime).subtract(15, 'minutes');
        const differenceInMinutes = moment(eventtime.replace(/-/g, "/")).diff(
            currenTime.replace(/-/g, "/"),
            "seconds"
        );
        console.log(differenceInMinutes, "differenceInMinutes", "seconds");
        setTimeLeft(differenceInMinutes);
        localStorage.setItem("ondemandLoader", "3");
        setloaderType("3");
        setIsActive(true);
        // return differenceInMinutes;
    };
    const checkTimesEnd = () => {
        let status = true;
        let currenTime = moment()
            .tz(timezone_name)
            .format("YYYY-MM-DD hh:mm A");

        let eventtime = moment(
            `${activeEvent.backupdate} ${activeEvent.end_time}`,
            "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DD hh:mm A");

        // let beforeTime = moment(eventtime).subtract(15, 'minutes');
        const differenceInMinutes = moment(eventtime.replace(/-/g, "/")).diff(
            currenTime.replace(/-/g, "/"),
            "seconds"
        );
        console.log(differenceInMinutes, "differenceInMinutes");
        return differenceInMinutes;

        // return differenceInMinutes;
    };
    const openTimer = (item) => {
        setActiveEvent(item);
        window.loadModal2("#TimerForEvent", "show");
    };

    const rejectPaired = () => {
        let body = {
            pair: pairedUsers,
            event_id: pairedevent_id,
        };
        handleStopSound();
        rejectOnDemandSession(body)
            .then((data) => {
                if (data.data.data) {
                    // toast.error("Sorry that partner is no longer available", { position: "top-center" })
                    setRunAgain(true);
                    setHangOn(false);
                    setIsActivePaired(false);
                    setSeconds(30);
                }
                console.log(data, "data");
            })
            .catch(() => { });
    };

    const acceptPaired = () => {
        setHangOn(true);
        let body = {
            pair: pairedUsers,
            event_id: pairedevent_id,
        };
        handleStopSound();
        // if (acceptSession) {
        //   createOnDemandBooking(body)
        //     .then((data) => {
        //       console.log(data);
        //       if (data.data.data) {
        //         console.log(data);
        //       }
        //     })
        //     .catch(() => { });
        // } else {
        acceptOnDemandSession(body)
            .then((data) => {
                console.log(data);

                if (data.data.data) {
                    console.log(data);
                } else {
                    setHangOn(false);
                }
            })
            .catch(() => { });
        // }
    };

    const addMediumToQueueAgain = (no) => {
        dispatch(setLoadingContent(`<div>${t("loading.pleaseWait")}</div>`));
        dispatch(setLoadingText(true));
        console.log(checkTimesEnd());
        if (checkTimesEnd() < 0) {
            dispatch(setLoadingContent(``));
            dispatch(setLoadingText(false));
            setloaderType("1");
            window.loadModal2("#TimeEndedPopup", "show");
            removeMediumFromQueue();
            return;
        }
        if (no == "no") {
            localStorage.removeItem("again_started");
        } else {
            localStorage.setItem("again_started", "yes");
        }
        let body = {
            pair: pairedUsers,
        };
        removePairFromCache(body)
            .then((data) => {
                dispatch(setLoadingContent(""));
                dispatch(setLoadingText(false));
                if (data.data.data) {
                    addMediumQueue(checkYes);
                }
            })
            .catch(() => {
                addMediumToQueueAgain(no);
            });
    };
    const handleStart = () => setIsActivePaired(true);
    const handleStop = () => setIsActivePaired(false);

    //effects

    const closePopup = (type) => {
        let body = {
            status: 1,
        };

        updateOnDemandBoxStatus(body)
            .then((data) => {
                // callProfile()
                if (type == undefined) {
                    addMediumQueue(checkYes);
                } else {
                    setloaderType("2");
                }
            })
            .catch(() => { });

        // localStorage.setItem("EmerGencyPopUp", "EmerGencyPopUp")
        window.loadModal2("#EmerGencyPopUp", "hide");
    };

    const getInfo = async () => {
        let browserinfo = await getBrowserData();
        let name = browserinfo.browser_info;
        let filterName = cache_clear_confirmations.filter(
            (info) => info.browser_info == name
        );
        console.log(
            filterName,
            "filterName",
            browserinfo,
            cache_clear_confirmations
        );
        if (
            (filterName.length && filterName[0].is_verified != 1) ||
            !filterName.length
        ) {
            setIs_verified(true);
        } else {
            setIs_verified(false);
        }
    };
    const getTopicFromName = (e) => {
        let value = e.target.value;
        console.log(fromTime, "fromTime");
        console.log(toTime, "toTime");
        setTopicValue(value)
        clearTimeout(timer);
        console.log(e.target.value.length, "e.target.value.length")
        const newTimer = setTimeout(() => {

            const from = moment().format("YYYY-MM-DD");
            const to = moment()
                .add(15, "days")
                .format("YYYY-MM-DD");
            setFromTime(from);
            setToTime(to);
            getEventList(from, to, inputValue, session_id, value);

        }, 2000);

        setTimer(newTimer);
    }
    const getEventsFromName = (e) => {
        seteventType('Upcoming');
        setChecked(false);
        let value = e.target.value;
        if (value == "96") {
            setTopicState(true)
        } else {
            setTopicState(false)
        }

        setsession_id(value)
        setSessionId(value);
        window.session_id = value;
        console.log(values, value)
        let topicData;
        if (value == "96") {
            topicData = topicValue;
        } else {
            topicData = '';
        }
        if (values.length) {
            getEventList(fromTime, toTime, inputValue, value, topicData);
        }
        else if (value === "") {
            const from = moment().format("YYYY-MM-DD");
            const to = moment()
                .add(1, "days")
                .format("YYYY-MM-DD");
            setFromTime(from);
            setToTime(to);

            getEventList(from, to, inputValue, value, topicData);
        }
        else {
            console.log(value, "value", "session_id", session_id, "session_id");
            const from = moment().format("YYYY-MM-DD");
            let to;
            if(value == "95"){
                to = moment()
                    .add(60, "days")
                    .format("YYYY-MM-DD");
            } else if (value == "101") {
                to = moment()
                    .add(90, "days")
                    .format("YYYY-MM-DD");
            }else{
                to = moment()
                    .add(15, "days")
                    .format("YYYY-MM-DD");
            }
            setFromTime(from);
            setToTime(to);

            getEventList(from, to, inputValue, value, topicData);
        }
    }
    useEffect(() => {
        getInfo();

        // if(cache_clear_confirmations.length >0 && )
        if (is_on_demand_box != 1) {
            // window.loadModal2('#EmerGencyPopUp', "show")
        }
        localStorage.removeItem("matched");
        localStorage.setItem("ondemandLoader", "1");
        // const from = moment().format("YYYY-MM-DD");
        // const to = moment()
        //     .add(1, "days")
        //     .format("YYYY-MM-DD");
        // setFromTime(from);
        // setToTime(to);
        let hostName = window.location.hostname;
        console.log(hostName, "hostName", comingFrom);
        if (comingFrom == "ondemand" || comingFrom == "groupcoaching" || comingFrom == "practicecircles" || comingFrom == "speakerEvents" || comingFrom == "coachedgroupcoaching" || comingFrom == "communitysupportgroups" || comingFrom == "allpracticecircles" || comingFrom == "speakerEventsPast") {
            console.log("comingFrom", comingFrom, "hostName", hostName);
            let ev = {
                target: {
                    value: comingFrom == "ondemand" && hostName == "app.verysoul.com" ? '91' :
                        comingFrom == "ondemand" && hostName == "staging.verysoul.com " ? '91' :
                            comingFrom == "groupcoaching" && hostName == "app.verysoul.com" ? '90' :
                                comingFrom == "groupcoaching" && hostName == "staging.verysoul.com" ? '83' :
                                comingFrom == "groupcoaching" && hostName == "localhost" ? '83' :

                                    comingFrom == "practicecircles" && hostName == "staging.verysoul.com" ? '93' :
                                        comingFrom == "practicecircles" && hostName == "app.verysoul.com" ? '93' :
                                            comingFrom == "speakerEvents" && hostName == "staging.verysoul.com" ? '95' :
                                                comingFrom == "speakerEvents" && hostName == "app.verysoul.com" ? '95' :
                                                comingFrom == "speakerEventsPast" ? '95' :
                                                    comingFrom == "coachedgroupcoaching" && hostName == "staging.verysoul.com" ? '94' :
                                                        comingFrom == "coachedgroupcoaching" && hostName == "app.verysoul.com" ? '94' :
                                                            comingFrom == "communitysupportgroups" && hostName == "staging.verysoul.com" ? '96' :
                                                                comingFrom == "communitysupportgroups" && hostName == "app.verysoul.com" ? '96' :
                                                                    comingFrom == "allpracticecircles" && hostName == "staging.verysoul.com" ? 0 :
                                                                    comingFrom == "allpracticecircles" && hostName == "localhost" ? 0 :
                                                                        comingFrom == "allpracticecircles" && hostName == "app.verysoul.com" ? 0 :

                                                                            '83'
                }
            }
            if(comingFrom == "speakerEventsPast"){
                const from = moment().format("YYYY-MM-DD");
                const to = moment()
                        .add(10, "days")
                        .format("YYYY-MM-DD");
                    setFromTime(from);
                    setToTime(to);
                seteventType('Past')
                     setChecked(true)
                setsession_id(95)
                setSessionId(95);
               pastSpeakerEvent()
            }else{
             seteventType('Upcoming')
                  setChecked(false)
                getEventsFromName(ev)
            }

            setTimeout(() => {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.delete("to");
                window.history.replaceState({}, document.title, newUrl.href);
            }, 1000);


        }
        else {
            if (session_id === "") {
                const from = moment().format("YYYY-MM-DD");
                const to = moment()
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);

                getEventList(from, to, inputValue, session_id, topicValue);
                console.log(session_id, "session_id session_id session_idsession_id session_id ", "1")
            }
            else {
                const from = moment().format("YYYY-MM-DD");
                let to;
                if(session_id == "95"){
                     to = moment()
                    .add(60, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                } else if (session_id == "101") {
                     to = moment()
                    .add(90, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                }else{
                     to = moment()
                    .add(15, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                }


                getEventList(from, to, inputValue, session_id, topicValue);
                console.log(session_id, "session_id session_id session_idsession_id session_id ", "2")
            }
            // getEventList(from, to, inputValue, session_id);

        }
    }, []);

    useEffect(() => {
        if (time > 0 && !ondemandStatus) {
            let status = checkOldTime(activeEvent.backupdate, activeEvent.end_time);
            if (status) {
                setOndamandStatus(true);
                removeMediumFromQueue();
                localStorage.setItem("ondemandLoader", "1");
                setloaderType("1");
                return;
            }
        }
    }, [time, ondemandStatus]);

    useEffect(() => {
        const handleBeforeUnload = (event, confirmExit) => {
            console.log(event, confirmExit);
            let ondemandLoader = localStorage.getItem("ondemandLoader");
            // if (ondemandLoader == "3") {
            event.preventDefault();
            setIsActive(false);
            removeMediumFromQueue();
            event.returnValue = "";
            // } else {
            //   event.preventDefault();
            // }
        };
        const handleUnload = (event) => {
            console.log(event);
            // event.preventDefault();
            setIsActive(false);
            removeMediumFromQueue();
            // event.returnValue = "";
            console.log("User chose to leave the page");
            // You can run any final cleanup code here before the page unloads
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("unload", handleUnload);

        // return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("unload", handleUnload);
        // };
    }, []);

    useEffect(() => {
         if(eventType == 'Past'){
            return;
        }
        Pusher.logToConsole = false;
        var pusher = new Pusher("823ab72ed6ecd563b8c8", {
            cluster: "ap2",
        });

        var channel = pusher.subscribe("ondemand-booking");
        channel.bind("App\\Events\\OnDemandBooking", function (data) {
            console.log(data, "data");
            if (data.appointment !== undefined) {
                if (
                    data.appointment.medium_id == id ||
                    data.appointment.user_id == id
                ) {
                    // console.log(data, "data");
                    setTime(0);
                    setCounterStatus(true);
                    setOndamandStatus(true);
                    setMessage(data.message);
                    setAppoinmentId(data.appointment.id);
                    localStorage.setItem("appoinmentId", data.appointment.id);
                    setmettingLink(data.appointment.meeting_link);
                    setIsActivePaired(false);
                    localStorage.setItem("matched", "matched");
                    // if (
                    //   data.appointment.meeting_link == null ||
                    //   data.appointment.meeting_link == ""
                    // ) {
                    //   getZoomLink(data.appointment.id);
                    // }
                    // setTimeout(() => {
                    navigate(
                        `/appointments?from=goondemand&appointment_id=${data.appointment.id}&message=${data.message}`
                    );
                    // }, 3000);
                    // setloaderType("4");

                    if (data.appointment.medium_id == id) {
                        setshoHostStatus(true);
                    } else {
                        setshoHostStatus(false);
                    }
                }
            }
        });
    }, []);

    useEffect(() => {
        localStorage.setItem("ONDEMAND", "ONDEMAND");
        return () => {
            localStorage.removeItem("matched");
            removeMediumFromQueue(); // Call the API when the component unmounts
            localStorage.removeItem("ONDEMAND");
        };
    }, []);

    useEffect(() => {
        console.log(activeEvent, "activeEvent");
        if (activeEvent !== undefined) {
            // window.loadModal2("#TimeEndedPopup", "show");
            console.log(checkTimesEnd());
            if (checkTimesEnd() === 0 && isActive) {
                removeMediumFromQueue();
                setloaderType("1");
                clearOnDemandCache(activeEvent.id).then(() => { });
                setIsActive(false);
                window.loadModal2("#TimeEndedPopup", "show");
                return;
            }
            // If the time reaches zero, stop the timer.

            let intervalId;

            if (isActive && timeLeft > 0) {
                intervalId = setInterval(() => {
                    // console.log(timeLeft, "setIsActive");
                    setTimeLeft((prevTime) => prevTime - 1);
                }, 1000);
            }
            return () => clearInterval(intervalId); // Clean up the interval on component unmount or if the timer stops
        }
    }, [isActive, timeLeft]);

    useEffect(() => {
        if (loaderType != "3") {
            setTimeLeft("");
            setIsActive(false);
        }
        if (loaderType == "1") {
            removeMediumFromQueue();
            localStorage.removeItem("activeEvent");
        }
    }, [loaderType]);

    useEffect(() => {
        if (runagain) {
            addMediumQueue(checkYes);
        }
    }, [runagain]);

    useEffect(() => {
        if (otherInfo !== undefined) {
            if (
                pairedUsers.includes(otherInfo.other_medium_id) &&
                pairedUsers.includes(otherInfo.user_id) &&
                parseInt(otherInfo.event_id) == parseInt(pairedevent_id)
            ) {
                seAcceptSession(true);
            }
        }
    }, [otherInfo]);

    useEffect(() => {
        let timerId;
        if (isActivePaired && seconds > 0) {
            timerId = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        if (isActivePaired && seconds == 0) {
            seAcceptSession(false);
            setloaderType("6");
            // window.loadModal2("#PartnerEndedPopup", "show");
            // toast.error("Sorry that partner is no longer available", { position: "top-center" })
            // addMediumQueue(checkYes);
            setHangOn(false);
            setIsActivePaired(false);
            setSeconds(30);
            // setTimeout(() => {
            //   if (localStorage.getItem("again_started") == "yes") {
            //     localStorage.removeItem("again_started");
            //   } else {
            //     addMediumToQueueAgain("no");
            //   }
            // }, 5000);
        }

        // Cleanup the interval on component unmount or when the timer stops
        return () => clearInterval(timerId);
    }, [isActivePaired, seconds]);

    //webhooks effects
    useEffect(() => {
        // if (loaderType == "3" || loaderType == "5") {
          if(eventType == 'Past'){
            return;
        }
        Pusher.logToConsole = false;
        var pusher = new Pusher("823ab72ed6ecd563b8c8", {
            cluster: "ap2",
        });
        const randomNumber = Math.floor(Math.random() * 10) + 1;
        console.log(parseInt(`${randomNumber}000`), "randomNumber");
        var channel = pusher.subscribe("on-demand-practice-medium-confirmation");
        channel.bind("App\\Events\\OnDemandPracticeMediumConfirmation", function (
            data
        ) {
            console.log(data, "on-demand-practice-medium-confirmation");
            if (data.pair.includes(id)) {
                setPairedUsers(data.pair);
                setpairedevent_id(data.event_id);
                localStorage.setItem("pairedUsers", JSON.stringify(data.pair));
                localStorage.setItem("pairedevent_id", data.event_id);
                localStorage.setItem("ondemandLoader", "5");
                let match = data.users.filter((info) => info.id !== id);
                setMatchName(match[0].screen_name);
                // setTimeout(() => {

                playMatchSound();

                setloaderType("5");
                setIsActivePaired(true);
                // }, parseInt(`${randomNumber}000`));
            }
        });
        // } else {
        //   var pusher = new Pusher("823ab72ed6ecd563b8c8", {
        //     cluster: "ap2",
        //   });
        //   pusher.unsubscribe("on-demand-practice-medium-confirmation");
        // }
    }, [loaderType]);

    useEffect(() => {
          if(eventType == 'Past'){
            return;
        }
        if (loaderType == "5") {
            Pusher.logToConsole = false;
            var pusher = new Pusher("823ab72ed6ecd563b8c8", {
                cluster: "ap2",
            });

            var channel = pusher.subscribe("reject-on-demand-practice-pairing");
            channel.bind("App\\Events\\RejectOnDemandPracticePairing", function (
                data
            ) {
                console.log(data, "RejectOnDemandPracticePairing");
                let pairedUsers = localStorage.getItem("pairedUsers");
                let pairedevent_id = localStorage.getItem("pairedevent_id");
                console.log(
                    pairedUsers,
                    "JSON.stringify(pairedUsers) === JSON.stringify(data.pair)"
                );
                if (
                    pairedUsers === JSON.stringify(data.pair) &&
                    parseInt(data.event_id) == parseInt(pairedevent_id)
                ) {
                    seAcceptSession(false);
                    seAcceptSession(false);
                    // setRunAgain(true);
                    if (parseInt(data.rejected_user) !== parseInt(id)) {
                        setloaderType("6");
                        // window.loadModal2("#PartnerEndedPopup", "show");
                        // setTimeout(() => {

                        //   addMediumToQueueAgain("no");
                        // }, 5000);
                    }
                }
                // if (data.pair.includes(id)) {
                //   setPairedUsers(data.pair);
                //   setpairedevent_id(data.event_id);
                //   setloaderType("5");
                // }
            });
        } else {
            var pusher = new Pusher("823ab72ed6ecd563b8c8", {
                cluster: "ap2",
            });
            pusher.unsubscribe("reject-on-demand-practice-pairing");
        }
    }, [loaderType]);

    useEffect(() => {
          if(eventType == 'Past'){
            return;
        }
        if (loaderType == "5") {
            Pusher.logToConsole = false;
            var pusher = new Pusher("823ab72ed6ecd563b8c8", {
                cluster: "ap2",
            });

            var channel = pusher.subscribe("on-demand-practice-medium-confirmed");
            channel.bind("App\\Events\\OnDemandPracticeMediumConfirmed", function (
                data
            ) {
                console.log(data, "OnDemandPracticeMediumConfirmed");
                console.log(pairedUsers, pairedevent_id);
                setOtherInfo(data);
            });
        } else {
            var pusher = new Pusher("823ab72ed6ecd563b8c8", {
                cluster: "ap2",
            });
            pusher.unsubscribe("on-demand-practice-medium-confirmed");
        }
    }, [loaderType]);
    useEffect(() => {
        if(eventType == 'Past'){
            return;
        }
        Pusher.logToConsole = false;
        var pusher = new Pusher("823ab72ed6ecd563b8c8", {
            cluster: "ap2",
        });
        var channel = pusher.subscribe("on-demand-event-update");
        channel.bind("App\\Events\\OnDemandEventUpdate", function (data) {
            console.log(data, "OnDemandEventUpdate", inputValue, session_id);
            if (window.values.length) {
                const startDate = window.values[0].format("YYYY-MM-DD");
                const endDate = window.values[1].format("YYYY-MM-DD");
                getEventListUpdate(startDate, endDate, window.inputValue, window.session_id);
            }
            else if (window.inputValue !== "") {
                console.log('event ')
                const from = moment().format("YYYY-MM-DD");
                const to = moment()
                    .add(15, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                getEventListUpdate(from, to, window.inputValue, window.session_id);
            }
            else if (window.session_id !== "") {

                const from = moment().format("YYYY-MM-DD");
                const to = moment()
                    .add(15, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                getEventListUpdate(from, to, window.inputValue, window.session_id);
            }
            else {


                const from = moment().format("YYYY-MM-DD");
                const to = moment()
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                setFromTime(from);
                setToTime(to);
                getEventListUpdate(from, to, window.inputValue, window.session_id);
            }
        });
        return () => {
            var pusher = new Pusher("823ab72ed6ecd563b8c8", {
                cluster: "ap2",
            });
            pusher.unsubscribe("on-demand-event-update");
        };
    }, []);
    function updateOldArray(oldArray, newArray) {
        console.log(oldArray, newArray, "oldArray, newArray")
        return oldArray.map(oldObj => {

            let match = newArray.find(newObj =>
                // {
                // console.log(newObj.time ,oldObj.time ,'oldtimes')
                // console.log(newObj.end_time ,oldObj.end_time ,'oldtimes')
                newObj.time === oldObj.time && newObj.end_time === oldObj.end_time

                // }
            );
            return match ? match : oldObj;
        });
    }
    const getEventListUpdate = (from, to, keyword, session_id) => {

        // setVisibleCount(5);
        // setDisabledFilters(true)
        setdisableLoadMore(false);
        getMediumOndemandEvents(from, to, keyword, session_id)
            .then((data) => {
                // setDisabledFilters(false)
                const events = Object.values(data.data.data).flat();
                // console.log(events, "events", data.data.data, "data.data.data");
                let newEvents = events.map((info) => {
                    return {
                        id: info.id,
                        description: info.description,
                        ondemand_session_category_id: info.ondemand_session_category_id,
                        name: info.title,
                        // time: times(info.start_time),
                        time: info.start_time,
                        monthname: month(info.date),
                        date: date(info.date),
                        dateInfo: info.date,
                        day: day(info.date),
                        fullday: fullday(info.date),
                        subtext: info.sub_text,
                        backupdate: info.date,
                        end_time: info.end_time,
                        // showReminder: checkTime(info.date, info.start_time, info.end_time),
                        is_event_started: info.is_event_started,
                        spots_left: info.spots_left !== undefined ? info.spots_left : "",
                        is_group_event:
                            info.is_group_event !== undefined ? info.is_group_event : false,
                        session_id: info.session_id !== undefined ? info.session_id : "",
                        medium_name: info.medium_name !== undefined ? info.medium_name : "",
                        medium_id: info.medium_id !== undefined ? info.medium_id : "",
                        duration: info.duration !== undefined ? info.duration : "",
                        title: info.title,
                        currency: info.currency !== undefined ? info.currency : "USD",
                        button_status: info.button_status !== undefined ? info.button_status : "0",
                        is_booked: info.is_booked !== undefined ? info.is_booked : "0",
                        price_for_attendees: info.price_for_attendees !== undefined ? info.price_for_attendees : null,
                        topic: info.topic !== undefined ? info.topic : '',
                        medium_availability_id: info.medium_availability_id !== undefined ? info.medium_availability_id : '',
                        language: info.language !== undefined ? info.language : '',
                        practice_circle_level_label: info.practice_circle_level_label !== undefined ? info.practice_circle_level_label : '',
                        is_worker_event: info.is_worker_event !== undefined ? info.is_worker_event : 0,
                        total_workers_required: info.total_workers_required !== undefined ? info.total_workers_required : 0,
                        workers_positions_left: info.workers_positions_left !== undefined ? info.workers_positions_left : 0,
                        total_spots_left: info.total_spots_left !== undefined ? info.total_spots_left : 0,
                        zoom_link: !!info.zoom_link,
                        appointment_id: info.appointment_id ? info.appointment_id : null
                    };
                });
                // console.log(eventsList);
                setEventList([]);

                let updatedArray = updateOldArray(window.eventsList, newEvents);
                console.log(updatedArray, "updatedArray");
                // console.log(newEvents, "newEvents");
                setEventList(newEvents);
                // runIntervalFunc(newEvents);
            })
            .catch(() => { });
    };

    useEffect(() => {
        window.inputValue = inputValue
        window.session_id = session_id
        window.values = values
    }, [inputValue, session_id, values])


    useEffect(() => {
        let interval;
        if (loaderType == "3") {
            interval = setInterval(() => {
                console.log("This runs every 2 seconds");
                checkMediumQueueAgain();
            }, 60000);
        }

        // Cleanup function to clear the interval
        return () => clearInterval(interval);
    }, [loaderType]);

    const checkMediumQueueAgain = () => {
        checkMediumInOnDemandQueue()
            .then((data) => {
                console.log(data.data.data.in_queue, "data");
                console.log(data.data.data.is_cache_cleared, "data");

                if (!data.data.data.in_queue) {
                    let event_id = activeEvent.id;
                    let date = activeEvent.backupdate;
                    let end_time = activeEvent.end_time;
                    let user_pereference = checkYes == "yes" ? 0 : 1;

                    addMediumToOnDemandQueue(event_id, date, end_time, user_pereference)
                        .then((data) => { })
                        .catch(() => { });
                }
            })
            .catch(() => { });
    };
    const openExitQueuePopup = () => {
        window.loadModal2("#ExitQueuePopup", "show");
        //backHandler();
    };
    const ExitQueue = () => {
        backHandler();
    };
    useEffect(() => {
        console.log("Current loaderType:", loaderType);
    }, [loaderType]);

    // Then in your mouseLeave handler, add more detailed logging
    const handleMouseLeave = (e) => {
        if (e.clientY <= 0) {
            console.log("Mouse left window, loaderType:", loaderType);
            if (loaderType === "3") {
                window.loadModal2("#ExitQueuePopup", "show");
            }
        }
    };

    useEffect(() => {
        console.log("Current loaderType:", loaderType);
    }, [loaderType]);

    useEffect(() => {
        const handleMouseLeave = (e) => {
            // Get the event properties in a cross-browser way
            const from = e.relatedTarget || e.toElement;

            // Check if mouse left the window
            if (!from || from.nodeName === "HTML") {
                console.log("Mouse left window, loaderType:", loaderType);
                if (loaderType === "3") {
                    setTimeout(() => {
                      //  window.loadModal2("#ExitQueuePopup", "show");
                    }, 700); // 1000ms = 1 second
                }
            }
        };

        // Use mouseleave for better cross-browser support
        document.addEventListener("mouseout", handleMouseLeave);

        // Cleanup event listener
        return () => {
            document.removeEventListener("mouseout", handleMouseLeave);
        };
    }, [loaderType]);

    const bookDirectAppointment = (info,worker="") => {
        console.log(worker, "worker");

        if(worker == 1){
            setIsWorker(1);
        }else{
            setIsWorker(0);
        }
        setdirectAppMediumInfo(info);
        console.log(info);
        window.loadModal2('#ScheduledetailsModal', 'hide')
        window.loadModal2("#BookAppointmentPopUp", "show");
        // window.loadModal2("#QuestionPopUp", "show");

    };
    const booKGroupEvent = () => {

        if (isBookingInProgress) {
            return;
        }
        setIsBookingInProgress(true);
        const selectedCurrency = directAppMediumInfo && directAppMediumInfo.currency !== undefined ? directAppMediumInfo.currency : "USD";


        dispatch(setLoadingContent(`<div>${t("loading.pleaseWait")}</div>`));
        dispatch(setLoadingText(true));
        console.log(directAppMediumInfo, "directAppMediumInfo");

        let body = {
            id:directAppMediumInfo.id,
            date: directAppMediumInfo.backupdate,
            time: directAppMediumInfo.time,
            service: directAppMediumInfo.session_id,
            session_length: directAppMediumInfo.ondemand_session_category_id,
            medium_id: directAppMediumInfo.medium_id,
            partner_level: [1, 2, 3, 4, 5, 6, 7],
            is_confirmed: false,
            duration: directAppMediumInfo.duration,
            time_slot_id: directAppMediumInfo.id,
            medium_availability_id: directAppMediumInfo.medium_availability_id,
            is_worker_appointment: isWorker,
            currency: selectedCurrency,
        };

        if (directAppMediumInfo.ondemand_session_category_id == 94 || directAppMediumInfo.ondemand_session_category_id == 95 || (directAppMediumInfo.ondemand_session_category_id == 101 && directAppMediumInfo.price_for_attendees != null)) {
            setBody(body);
            mediumInfo(body)
                .then((data) => {
                    dispatch(setLoadingContent(``));
                    dispatch(setLoadingText(false));
                    setIsBookingInProgress(false);


                    if (data.data.status) {
                        console.log(data.data.data.amount, "dataAmount");
                        if (data.data.data.amount == null) {
                            return;
                        }
                         setMediumValue({
                            ...data.data.data,
                            currency: selectedCurrency,
                        });
                        if (data.data.data.pay_forward == 1) {
                            setpayItforwardValue(data.data.data.amount);
                            setpayItforwardFixPrice(data.data.data.amount);
                             const responseData = {
                                ...data.data.data,
                                ondemand_session_category_id: data.data.data.subsession_id,
                                backupdate: directAppMediumInfo.backupdate,
                                backuptime: directAppMediumInfo.time,
                                currency: selectedCurrency,
                                };
                            setActivePay(responseData)
                            window.loadModal2("#BookAppointmentPopUp", "hide");
                            window.loadModal2("#QuestionPopUp", "hide");
                            window.loadModal2("#PayItForwardPopUp", "show");
                        } else {
                            let body = {
                                id:directAppMediumInfo.id,
                                date: directAppMediumInfo.backupdate,
                                time: directAppMediumInfo.time,
                                service: directAppMediumInfo.session_id,
                                session_length: directAppMediumInfo.ondemand_session_category_id,
                                medium_id: directAppMediumInfo.medium_id,
                                partner_level: [1, 2, 3, 4, 5, 6, 7],
                                is_confirmed: false,
                                duration: directAppMediumInfo.duration,
                                time_slot_id: directAppMediumInfo.id,
                                amount: data.data.data.amount,
                                 currency: selectedCurrency,
                            };
                            setBody(body);
                            window.loadModal2("#payoptionspopupmediumbooking", "show");
                            window.loadModal2("#BookAppointmentPopUp", "hide");
                            window.loadModal2("#QuestionPopUp", "hide");
                        }
                    } else {
                        toast.error(data.data.message, {
                            position: "top-center",
                        });
                    }
                })
                .catch(() => {
                    setIsBookingInProgress(false);

                });
        } else {

            let id = body.id;

            createMediumBooking(body, true)
                .then(async (data) => {
                    if (data.data.status) {
                        const isCommunityBooking = isCommunitySupportBooking(directAppMediumInfo);

                        if (!isCommunityBooking) {
                            updateSpots(id);
                        }
                        setslotDetails(data.data.data);
                        setBookedItemIds(prev =>
  prev.includes(Number(directAppMediumInfo.id))
    ? prev
    : [...prev, Number(directAppMediumInfo.id)]
);

setEventList(prev =>
  prev.map(item =>
    item.id === directAppMediumInfo.id
      ? { ...item, is_booked: 1 }
      : item
  )
);
                        window.loadModal2("#BookAppointmentPopUp", "hide");
                        window.loadModal2("#QuestionPopUp", "hide");

                        if (isCommunityBooking) {
                            try {
                                await refreshCommunityEventsAfterBooking();
                            } catch (err) {
                                setShowCommunityRefreshRetry(true);
                                toast.warning(t("toasts.bookingRefreshFailed"), {
                                    position: "top-center",
                                });
                            }
                        }

                        console.log(body.id, "bodydata check");
                      //  setloaderType("CONFIRM");
                       // 🔹 Clean up previous subscription if exists
        // if (cleanupRef.current) {
        //   cleanupRef.current();
        // }
        //               cleanupRef.current = startPusherListener();


                      window.loadModal2("#BookingConfirmPopUp", "show");
                        toast.success(data.data.message, {
                            position: "top-center",
                        });
                        dispatch(setLoadingContent(``));
                        dispatch(setLoadingText(false));
                    } else {
                        dispatch(setLoadingContent(``));
                        dispatch(setLoadingText(false));
                        toast.error(data.data.message, {
                            position: "top-center",
                        });
                    }
                    setIsBookingInProgress(false);
                })
                .catch(() => {
                    dispatch(setLoadingContent(``));
                    dispatch(setLoadingText(false));
                    setIsBookingInProgress(false);
                });
        }
    };
    const payItForwardHandler = () => {
        const updatedBody = {
            ...body,
            amount: Number(payItforwardValue),
            appointment_type: "paybefore",
            booking_type: 'paid',
            method: 'stripe',
            payItforward: 1,
        };
        createGroupSessionPaidBooking(updatedBody).then((data) => {
            console.log(data.data.status, "data.data", updatedBody)
            if (data.data.status) {
                if ((directAppMediumInfo.session_id === 2 || directAppMediumInfo.session_id === 29 || directAppMediumInfo.session_id === 35) && (updatedBody !== undefined && updatedBody.booking_type === 'paid')) {
                    window.open(data.data.data.approvedUrl, "_self");
                    localStorage.setItem('bookingType', 'coaching');
                }
                else {
                    toast.success(data.data.message, {
                        position: "top-center",
                    });

                }
            }
            else {
                toast.error(data.data.message, {
                    position: "top-center",
                });
            }
        }).catch(() => { })
    }
    const createBooking = (item) => {
        const updatedBody = {
            ...body,
            appointment_type: "paybefore",
            booking_type: 'paid',
            method: item.paymenttype,
        };
        createGroupSessionPaidBooking(updatedBody).then((data) => {
            console.log(data.data.status, "data.data", updatedBody)
            if (data.data.status) {
                if ((directAppMediumInfo.session_id === 2 || directAppMediumInfo.session_id === 29 || directAppMediumInfo.session_id === 35) && (updatedBody !== undefined && updatedBody.booking_type === 'paid')) {
                    window.open(data.data.data.approvedUrl, "_self");
                    localStorage.setItem('bookingType', 'coaching');
                }
                else {
                    toast.success(data.data.message, {
                        position: "top-center",
                    });

                }
            }
            else {
                toast.error(data.data.message, {
                    position: "top-center",
                });
            }
        }).catch(() => { })
    }
    const createBookingMedium = (bodydata) => {
        let id = bodydata.id;

        createMediumBooking(bodydata, true)
            .then((data) => {
                dispatch(setLoadingContent(``));
                dispatch(setLoadingText(false));
                if (data.data.status) {
                    setslotDetails(data.data.data);
                    updateSpots(id);
                    window.loadModal2("#BookAppointmentPopUp", "hide");
                    window.loadModal2("#QuestionPopUp", "hide");
                    //setloaderType("CONFIRM");
                    window.loadModal2("#BookingConfirmPopUp", "show");
                    console.log(bodydata.id ,"bodydata check ");
                    setEventList(prev =>
                            prev.filter(item => item.id !== bodydata.id)
                        );
                    setBookedItemIds(prev => [...prev, bodydata.id]);
                    toast.success(data.data.message, {
                        position: "top-center",
                    });
                } else {
                    toast.error(data.data.message, {
                        position: "top-center",
                    });
                }
            })
            .catch(() => {
                dispatch(setLoadingContent(``));
                dispatch(setLoadingText(false));
            });
    }
    const continueBrowsing =()=>{
         window.loadModal2("#BookingConfirmPopUp", "hide")
    }
    const updateSpots = (id) => {
            setEventList((prev) =>

                        prev.map((event) => {
                        if (event.id === id) {
                            // extract the number from "30 spots left(of 30)"
                            const match = event.spots_left.match(/^(\d+)\s/);
                            if (match) {
                            let currentSpots = parseInt(match[1], 10);
                            let newSpots = currentSpots - 1;

                            // replace only the first number with newSpots
                            const updatedSpots = event.spots_left.replace(
                                /^\d+/,
                                newSpots.toString()
                            );

                            return { ...event, spots_left: updatedSpots };
                            }
                        }
                        return event;
                        })
                    );
                };
   const onChange = () => {
        const from = moment().format("YYYY-MM-DD");
        const to = moment()
            .add(10, "days")
            .format("YYYY-MM-DD");
        setFromTime(from);
        setToTime(to);
        setChecked(prev => {
            const next = !prev;
              const newType = next ? "Past" : "Upcoming";
            seteventType(newType);
            console.log(newType)
            if(newType == "Past"){
                pastSpeakerEvent();
            }else{
                getEventList(from, to, '', session_id,"","","upcoming");
            }

            return next;
        });
    };
   useEffect(() => {
    const pusher = new Pusher("823ab72ed6ecd563b8c8", { cluster: "ap2" });
    const channel = pusher.subscribe("special-event-booking-confirmation");

    channel.bind("App\\Events\\SpecialEventBookingConfirmation", (data) => {
        console.log("📢 Event received in this tab/window:", data, session_id);
        getEventsFromName({ target: { value: session_id } }); // your fair event logic
    });

    return () => {
        channel.unbind_all();
        channel.unsubscribe();
        pusher.disconnect();
    };
}, []);
const handleClick = (data) => {
    if(data.ondemand_session_category_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID || data.ondemand_session_category_id == 94){
        console.log("Category ID:", data);
        const pageState = {
                serviceValue: 2,
                service: "Coaching Sessions",
                serviceTypeList: [
                    { id: 0, name: "1 on 1" },
                    { id: 1, name: "Group Session" },
                ],
                sessionLength: data.ondemand_session_category_id,
                serviceType: "1",
                sessionLengthList: [
                    { id: process.env.REACT_APP_COACHING_GROUP_SESSION_ID, sub_session_name: "Group Coaching", session_type: 2, duration: "30", pricing_type: "free" },
                    { id: 94, sub_session_name: "Coached Practice Circles", session_type: 2, duration: "60", pricing_type: "fixed" },
                ],
                pricingType: "free",
                coachingTypeBackup: "free",
                coachingType: "paid",
                coachType: "",
                selectedMediumId: data.medium_id, // Store the selected medium ID
                };
            sessionStorage.setItem("bookingPageState", JSON.stringify(pageState));
            if(data.ondemand_session_category_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID ){

                navigate(`/coach-reviews/${data.medium_id}?from=booking&serviceValue=${2}&page=group&comingFrom=groupcoaching`);
            }else{
                navigate(`/coach-reviews/${data.medium_id}?from=booking&serviceValue=${2}&page=group&comingFrom=allpracticecircles`);
            }
         //navigate(`/coach-reviews/${data.medium_id}?from=booking&serviceValue=${2}`);
    }
};
const handleJoinZoom = async (item) => {
   
  try {
    const body = {
      appointment_id: item.appointment_id,
      user_id: id,
    };

    const res = await getZoomLinkAppt(body);
console.log(res.data.data.zoom_link, "Zoom Link Response");
    if (res && res.data && res.data.status) {
      const zoomUrl =
        res.data && res.data.data && res.data.data.zoom_link;
console.log(zoomUrl, "zoomUrl");
      if (zoomUrl) {
    //     toast.success("Zoom link retrieved", {
    //     position: "top-center",
    //   });
        window.open(zoomUrl, "_blank", "noopener,noreferrer");
      } else {
        toast.error(
          (res && res.data && res.data.message) ||
            t("toasts.zoomLinkUnavailable"),
          { position: "top-center" }
        );
      }
    } else {
      toast.error(
        (res && res.data && res.data.message) || t("toasts.somethingWentWrong"),
        { position: "top-center" }
      );
    }
  } catch (error) {
    console.error(error);
    toast.error(t("toasts.serverError"), {
      position: "top-center",
    });
  }
};
const booKGroupEventconfirm = () => {

    window.loadModal2("#BookAppointmentPopUp", "hide");
    window.loadModal2("#QuestionPopUp", "show");
}

    return (
        <>
 <audio ref={audioRef} src={"/ring/ringNew.wav"} loop preload="auto" />

            <>
                {loaderType == "3" && (
                    <>
                        <div className="globe-gif-wrapper">
                            <div
                                onClick={backHandler}
                                className="back-btn-appointments pointer"
                            >
                                <div className="bck back-btn-go-ondemand-practice">
                                    <img src={"/ondemand-icons/arrow-back.png"} alt="back" />
                                    <p className="margin-unset"> {t("actions.back")} </p>
                                </div>
                            </div>
                        </div>
                        <div className="godemantevent-activeevent-info">
                            <div className="globe-gif-wrapper globe-gif-wrapper-padd">
                                <h4 className="text-left godemantevent-activeevent-info-heading mb-3 mt-3">
                                    {/* {console.log(activeEvent)} */}
                                    {activeEvent !== undefined && tc(activeEvent.name)}
                                </h4>
                                <p className="line-height-30px  font-size-20">
                                    {t("queue.searching")}
                                    <br /> {t("queue.leavingStops")}
                                </p>
                            </div>
                        </div>
                        <div className="globe-gif-wrapper globe-gif-wrapper-margins ">
                            <img
                                className="w-100 globe-image"
                                // src={"/ondemand-icons/loader.png"}
                                src={"/localImages/AroundTheWorld.gif"}
                                alt="globe"
                            />
                        </div>
                        {/* <video className="loader-video" autoPlay loop>
            <source src={"/localImages/AroundTheWorld.mp4"} type="video/mp4" />
          </video> */}
                        <div className="d-flex align-items-center justify-content-around mt-3">
                            <div
                                onClick={backHandler}
                                className="font-size-22 width-350-px white-border pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center border-radius-40"
                            >
                                {t("queue.exitQueue")}
                            </div>
                        </div>
                    </>
                )}
                {loaderType == "1" && (
                    <div className="container-fluid ">
                        <div className="container-fluid ">
                            <div className="dashboard ">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="middle-screen-name w-100 font-size-22 mt-2 mb-2">
                                            <div style={{ marginBottom: "15px" }}>
                                                <TimeDisplay format="HH:mm:ss A" />
                                            </div>
                                            <b>
                                                {t("events.timezone", { timezone: timezone !== undefined ? timezone : "" })}&nbsp; { }
                                            </b>
                                            
                                        </div>
                                        <div className="ondemandpractice-wrapper-medium-practice position-relative">
                                            {disabledfilters && <div className="ondemandpractice-wrapper-medium-practice-loader">

                                                <div className="ondemandpractice-wrapper-medium-practice-spinner spinner-text">
                                                    <div>

                                                        <ClockLoader size={60} color={"#d5a67b"} />
                                                        <p className="mt-2 d-block">
                                                            {" "}
                                                            <div dangerouslySetInnerHTML={{ __html: t("loading.pleaseWaitShort") }} />{" "}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>}
                                            <div></div>
                                            <div className="ondemandpractice-wrapper-medium-practice-filter-secion justify-content-between  d-flex-flex-wrap-wrap">
                                                <div className="custom-select-goondemand-wrapper d-flex align-items-center flex-wrap">
                                                    <div className="font-weight-bold font-size-17 mr-2">
                                                        {t("filters.label")}
                                                    </div>
                                                    <div class="custom-select-goondemand">
                                                        <div class="select-box-goondemand">
                                                            <select name="sessions_name" value={session_id} onChange={getEventsFromName}>
                                                                <option value={""} disabled>{t("filters.sessionType")}</option>

                                                                {sessions.map((info) => <option value={info.id}>{tc(info.sub_session_name)}</option>)}
                                                                {/* <option value={0} selected>{'All Practice Circles'}</option> */}
                                                                {/* <option value={"all"} selected>{'All'}</option> */}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                {topicstate && <div className="custom-select-goondemand-wrapper">
                                                    <div class="custom-select-goondemand">
                                                        <div class="select-box-goondemand">
                                                            <select onChange={getTopicFromName} value={topicValue} name="sessions_name">
                                                                <option value={""} selected disabled>{t("filters.topics")}</option>
                                                                {newTopic.map((topic) => (
                                                                    <option value={topic.topic}>{tc(topic.topic)}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className="search-box search-container ">
                                                    <input
                                                        value={inputValue}
                                                        onChange={inputChanged}
                                                        className="search-input"
                                                        // type={filterValues === "created_at" ? "date" : "text"}
                                                        placeholder={t("filters.search")}
                                                    />
                                                </div>

                                                <div className="filter-wrapper filter-container-box">
                                                    <MultiDatePicker
                                                        style={{ height: "45px" }}
                                                        className="search-input "
                                                        numberOfMonths={2}
                                                        disableMonthPicker
                                                        disableYearPicker
                                                        range
                                                        value={values}
                                                        onChange={handleValueChange}
                                                        placeholder={t("filters.dateRange")}
                                                        minDate={new Date()}
                                                    // maxDate={new Date()}
                                                    />
                                                </div>
                                                <div className="ondeand-practive-reset-btn-container" >

                                                    <button className="ondeand-practive-reset-btn ml-2" onClick={resetEvents} title={t("filters.reset")}>
                                                        {t("filters.reset")}
                                                    </button>
                                                </div>

                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center justify-content-between mt-3 pad-20 pb-0">
                                                    <h3 className="ondemandpractice-heading-ractice-mediums mb-0">
                                                        {t("events.heading")}
                                                    </h3>
                                                    {showCommunityRefreshRetry && (
                                                        <button
                                                            className="ondeand-practive-reset-btn ml-2"
                                                            onClick={retryCommunityRefresh}
                                                            disabled={isBookingInProgress}
                                                        >
                                                            {t("events.retryRefresh")}
                                                        </button>
                                                    )}
                                                     {session_id == 95 && (
                                                        <div className="toggle-wrapper-se">
                                                        <span className="toggle-label">{t("events.upcoming")}</span>
                                                        <div style={{ width: "60px" }}>
                                                            {/* your toggle inside here */}
                                                        </div>
                                                        <div className="toggle-button-cover toggle-button-cover-se">

                                                        <div className="button-cover">
                                                            <div className="button r se" id="button-1" onClick={onChange}>

                                                            <input
                                                                type="checkbox"
                                                                checked={checked}
                                                                name="toggle"
                                                                className="checkbox"
                                                            />

                                                            <div className="knobs round"></div>
                                                            <div className="layer round"></div>
                                                            </div>
                                                        </div>

                                                        </div>
                                                          <span className="toggle-label">{t("events.past")}</span>
</div>
                                                    )}
                                                </div>
                                                <p className="ondemandpractice-heading-ractice-mediums-text"> {t("events.fullHidden")}</p>
                                            </div>
                                            <div>
                                                <ul className="godemantevent-box-list min-height-50vh pad-20">
                                                    {/* eventsList
                                                            .slice(0, visibleCount)
                                                            .map((item, index) => ( */}
                                                    {eventsList.length > 0 ?
                                                        eventsList
                                                            .map((item, index) => (
                                                                <>
                                                                    {console.log(item, "item  item")}
                                                                    {item.is_group_event ? (
                                                                        <li>
                                                                            <div className="godemantevent-box">
                                                                                <div className="godemantevent-internal-box d-flex-flex-wrap-wrap">
                                                                                    <div className={`godemantevent-date-box ${eventType != "Upcoming" ? "pastDate" : ""}`}>
                                                                                        {eventType === "Upcoming" ?
                                                                                        <div className="ondemand-calendar-box">
                                                                                            <div className="ondemand-calendar-box-internal">
                                                                                                <div className="month-name">
                                                                                                    <span>{monthLabel(item)}</span>
                                                                                                </div>
                                                                                                <div className="month-date mt-1">
                                                                                                    <span>{item.date}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        :  <span className="spSpam">{formatDate(item.dateInfo, { month: "long", day: "numeric", year: "numeric" }, format(new Date(item.dateInfo), "MMMM d, yyyy"))}</span>}
                                                                                    </div>

                                                                                    <div className="godemantevent-date-box width-55 pointer">
                                                                                        {eventType === "Upcoming" &&
                                                                                        <div>
                                                                                            <span className="ondemandpractice-date-box-day">
                                                                                                <span aria-hidden="true">
                                                                                                    <span>{dayLabel(item)}</span>
                                                                                                    <span class="sc-1idcr5x-1 dieHWG">
                                                                                                        <span>
                                                                                                            {item.time}{" "}
                                                                                                            {getTimeImage(item.time) ? (
                                                                                                                <img
                                                                                                                    src="localImages/moon.png"
                                                                                                                    className="star-imh-moon"
                                                                                                                    alt="time-image"
                                                                                                                />
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}
                                                                                                        </span>{" "}
                                                                                                        -{" "}
                                                                                                        <span>
                                                                                                            {item.end_time}{" "}
                                                                                                            {getTimeImage(
                                                                                                                item.end_time
                                                                                                            ) ? (
                                                                                                                <img
                                                                                                                    src="localImages/moon.png"
                                                                                                                    className="star-imh-moon"
                                                                                                                    alt="time-image"
                                                                                                                />
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}{" "}
                                                                                                            ({
  item.ondemand_session_category_id == "95"
    ? t("events.speakerEvent")
    : item.ondemand_session_category_id == "101"
      ? t("events.professionalDemonstration")
      : tc(item.title)
})
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        }
                                                                                        <div>
                                                                                            <span class="sc-fyofxi-6 ivIeWB">
                                                                                                <span class="sc-fyofxi-5 gJmuwa godemantevent-activeevent-info-heading font-size-20 www"   onClick={() => handleClick(item)}>
                                                                                                  {eventType === "Upcoming" ? (
                                                                                                    item.ondemand_session_category_id === 96 ? tc(item.topic)
                                                                                                    : tc(item.title)
                                                                                                    ) : (
                                                                                                    (() => {
                                                                                                        const titleParts = item.title.split(/Hosted By/i);
                                                                                                        const titleBefore = titleParts[0] ? titleParts[0].trim() : "";
                                                                                                        const hostedBy = titleParts[1]
                                                                                                        ? t("events.hostedBy", { name: titleParts[1].trim() })
                                                                                                        : null;

                                                                                                        return (
                                                                                                        <>
                                                                                                            <div>{tc(titleBefore)}</div>

                                                                                                        </>
                                                                                                        );
                                                                                                    })()
                                                                                                    )}
                                                                                                    {item.ondemand_session_category_id != 95 && item.ondemand_session_category_id != 101 && eventType === "Upcoming" ? t("events.byMedium", { name: item.medium_name }) : ""}
                                                                                                    {" "}{getSpecialEventLanguageLabel(item, {}, { tc, tLanguage })}

                                                                                                </span>

                                                                                                {/* {item.ondemand_session_category_id == 96 && <span class="ondemandpractice-date-box-day d-block">{item.topic}</span>} */}
                                                                                            </span>
                                                                                            <span class="sc-fyofxi-7 jWLmQR">
                                                                                                <span class="sc-fyofxi-5 gJmuwa">
                                                                                                    {eventType == "Upcoming" ? tc(item.subtext):(() => {
                                                                                                        const titleParts = item.title.split(/Hosted By/i);
                                                                                                        const titleBefore = titleParts[0] ? titleParts[0].trim() : "";
                                                                                                        const hostedBy = titleParts[1]
                                                                                                        ? t("events.hostedBy", { name: titleParts[1].trim() })
                                                                                                        : null;

                                                                                                        return (
                                                                                                        <>
                                                                                                           {hostedBy && <div>{hostedBy}</div>}

                                                                                                        </>
                                                                                                        );
                                                                                                    })()}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        {(item.ondemand_session_category_id == "95" ||item.ondemand_session_category_id == "101") && <div
                                                                                            onClick={() =>
                                                                                                getClientProfileDetails(item, index)
                                                                                            }
                                                                                            className="more-info-go-ondemand-practice d-flex align-items-center"
                                                                                        >
                                                                                            <span className="inline-block">

                                                                                                {t("events.moreDetails")}
                                                                                            </span>
                                                                                            <img src={'./ondemand-icons/arrow-icon-black.png'} />
                                                                                        </div>}
                                                                                    </div>

                                                                                    <div className="godemantevent-date-box godemantevent-date-button-box text-right">
                                                                                        <div className="godemantevent-date-button-box-before"></div>
                                                                                        <div className="ondemand-button-box text-center">


                                                                                        </div>
                                                                                        <div className="ondemand-button-box text-center">
                                                                                             {item.is_worker_event == 1 && (item.workers_positions_left > 0 )  && (item.ondemand_session_category_id == 99 || item.ondemand_session_category_id == 101) &&
                                                                                            <div>
                                                                                             {/* () => { } */}
                                                                                            {item.ondemand_session_category_id != "95" &&
                                                                                                (t("events.workerSpotsLeft", { count: item.workers_positions_left, total: item.total_workers_required }))}


                                                                                            {eventType === "Upcoming" && (
                                                                                                <a
                                                                                                    onClick={(e) => {
                                                                                                    if (item.is_booked === 1 || bookedItemIds.includes(item.id)) {
                                                                                                        e.preventDefault(); // prevent the default action
                                                                                                        return;
                                                                                                    }
                                                                                                    bookDirectAppointment(item,1);
                                                                                                    }}

                                                                                                    className={`width-175-px   kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.is_booked == 1 || bookedItemIds.includes(item.id) ? "disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg ondemand-diabled" : ""}  ${item.is_event_started ? "Green-bg-all" : ""}`}
                                                                                                >
                                                                                                    <span className="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                    <span className="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                        {bookedItemIds.includes(item.id)
                                                                                                        ? t("events.bookedAsWorker")
                                                                                                        : item.ondemand_session_category_id === 94 || item.ondemand_session_category_id === 95
                                                                                                        ? t("events.bookAsWorker")
                                                                                                        : t("events.bookAsWorker")}
                                                                                                    </span>
                                                                                                    </span>
                                                                                                </a>
                                                                                                )
                                                                                                }
                                                                                                </div>
                            }
                                                                                            {/* () => { } */}
                                                                                           {(item.ondemand_session_category_id != 99 && item.ondemand_session_category_id != 101) &&
                                                                                            <div>
                                                                                            {item.ondemand_session_category_id != "95" &&
                                                                                                tSpots(item.spots_left)
                                                                                            }

                                                                                            {eventType === "Upcoming" ? (
                                                                                                <a
                                                                                                    onClick={(e) => {
                                                                                                    if (item.is_booked === 1 || bookedItemIds.includes(item.id)) {
                                                                                                        e.preventDefault(); // prevent the default action
                                                                                                        return;
                                                                                                    }
                                                                                                    bookDirectAppointment(item);
                                                                                                    }}

                                                                                                    className={`width-175-px   kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.is_booked == 1 || bookedItemIds.includes(item.id) ? "disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg ondemand-diabled" : ""}  ${item.is_event_started ? "Green-bg-all" : ""}`}
                                                                                                >
                                                                                                    <span className="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                    <span className="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                        { item.is_booked === 1 || bookedItemIds.includes(item.id)
                                                                                                        ? t("events.booked")
                                                                                                         : item.ondemand_session_category_id === 99
                                                                                                            ? t("events.bookAsAudience")
                                                                                                        : item.ondemand_session_category_id === 94 || item.ondemand_session_category_id === 95
                                                                                                        ? (item.price_for_attendees !== null ? t("events.bookDash") : t("events.bookFree"))
                                                                                                        : t("events.bookAppointment")}
                                                                                                    </span>
                                                                                                    </span>
                                                                                                </a>
                                                                                                ) : (
                                                                                                <a
                                                                                                    className={`width-175-px   kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.video == null ? "disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg ondemand-diabled" : ""} `}
                                                                                                    onClick={() =>
                                                                                                    openModalHandler(2, item.video)
                                                                                                    }
                                                                                                >
                                                                                                     <span className="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                    <span className="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                    {t("events.video")}
                                                                                                    </span>
                                                                                                    </span>

                                                                                                </a>
                                                                                                )}
                                                                                                {/* {eventType === "Upcoming" && (item.is_booked === 1 || bookedItemIds.includes(item.id)) && item.zoom_link && (
                                                                                                <a
                                                                                                    href={item.zoom_link}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    className="join-zoom-btn width-175-px d-block text-center mt-2"
                                                                                                >
                                                                                                    Join Zoom here
                                                                                                </a>
                                                                                                )} */}
                                                                                           </div>
                                                                                            }

                                                                                            {((item.ondemand_session_category_id == 99 || item.ondemand_session_category_id == 101) && item.total_spots_left > 0 && item.is_booked != 1) && 
                                                                                            <div>
                                                                                            {item.ondemand_session_category_id != "95" &&
                                                                                                tSpots(item.spots_left)
                                                                                            }

                                                                                            {eventType === "Upcoming" ? (
                                                                                                <a
                                                                                                    onClick={(e) => {
                                                                                                    if (item.is_booked === 1 || bookedItemIds.includes(item.id)) {
                                                                                                        e.preventDefault(); // prevent the default action
                                                                                                        return;
                                                                                                    }
                                                                                                    bookDirectAppointment(item);
                                                                                                    }}

                                                                                                    className={`width-175-px   kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.is_booked == 1 || bookedItemIds.includes(item.id) ? "disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg ondemand-diabled" : ""}  ${item.is_event_started ? "Green-bg-all" : ""}`}
                                                                                                >
                                                                                                    <span className="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                    <span className="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                        {item.is_booked === 1 || bookedItemIds.includes(item.id)
                                                                                                        ? t("events.booked")
                                                                                                         : (item.ondemand_session_category_id === 99 || item.ondemand_session_category_id === 101)
                                                                                                            ?item.price_for_attendees !== null ? t("events.bookPrice", { price: item.price_for_attendees, currency: item.currency }) : t("events.bookHere")
                                                                                                        : item.ondemand_session_category_id === 94 || item.ondemand_session_category_id === 95
                                                                                                        ? (item.price_for_attendees !== null ? t("events.bookPrice", { price: item.price_for_attendees, currency: item.currency }) : t("events.bookFree"))
                                                                                                        : t("events.bookAppointment")}
                                                                                                    </span>
                                                                                                    </span>
                                                                                                </a>
                                                                                                ) : (
                                                                                                <a
                                                                                                    className={`width-175-px   kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.video == null ? "disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg ondemand-diabled" : ""} `}
                                                                                                    onClick={() =>
                                                                                                    openModalHandler(2, item.video)
                                                                                                    }
                                                                                                >
                                                                                                     <span className="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                    <span className="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                    {t("events.video")}
                                                                                                    </span>
                                                                                                    </span>

                                                                                                </a>
                                                                                                )}
                                                                                               
                                                                                           </div>
                                                                                            }
                                                                                            <div>
                                                                                                {eventType === "Upcoming"  && item.is_booked != 0 && (item.ondemand_session_category_id == 99 || item.ondemand_session_category_id == 101 ) && (
                                                                                                <a
                                                                                                    onClick={(e) => {
                                                                                                    if (item.button_status === 1 || item.is_booked == 1|| bookedItemIds.includes(item.id)) {
                                                                                                        e.preventDefault(); // prevent the default action
                                                                                                        return;
                                                                                                    }
                                                                                                    bookDirectAppointment(item);
                                                                                                    }}

                                                                                                    className={`width-230-px kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.show_booking_button == 0 ? "d-none" : ""} ${item.button_status == 1 || item.is_booked == 1 || bookedItemIds.includes(item.id) ? "disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg ondemand-diabled" : ""}  ${item.is_event_started ? "Green-bg-all" : ""}`}
                                                                                                >
                                                                                                    <span className="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                    <span className="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                       {t("events.booked")}
                                                                                                    </span>
                                                                                                    </span>
                                                                                                </a>
                                                                                                ) }
                                                                                                </div>
                                                                                            <div>
                                                                                                 {eventType === "Upcoming" && item.is_booked === 1  && item.zoom_link == true && (
                                                                                                <a
                                                                                                   href="#"
                                                                                                    onClick={(e) => {
                                                                                                        e.preventDefault();
                                                                                                        handleJoinZoom(item);
                                                                                                    }}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    className="join-zoom-btn width-175-px d-block text-center mt-2"
                                                                                                >
                                                                                                    {t("events.joinZoomHere")}
                                                                                                </a>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ) : (
                                                                        <li>
                                                                            <div className="godemantevent-box">
                                                                                <div className="godemantevent-internal-box d-flex-flex-wrap-wrap">
                                                                                    <div className="godemantevent-date-box">
                                                                                        <div className="ondemand-calendar-box">
                                                                                            <div className="ondemand-calendar-box-internal">
                                                                                                <div className="month-name">
                                                                                                    <span>{monthLabel(item)}</span>
                                                                                                </div>
                                                                                                <div className="month-date mt-1">
                                                                                                    <span>{item.date}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="godemantevent-date-box width-55 pointer">
                                                                                        <div>
                                                                                            <span className="ondemandpractice-date-box-day">
                                                                                                <span aria-hidden="true">
                                                                                                    <span>{dayLabel(item)}</span>
                                                                                                    <span class="sc-1idcr5x-1 dieHWG">
                                                                                                        <span>
                                                                                                            {item.time}{" "}
                                                                                                            {getTimeImage(item.time) ? (
                                                                                                                <img
                                                                                                                    src="localImages/moon.png"
                                                                                                                    className="star-imh-moon"
                                                                                                                    alt="time-image"
                                                                                                                />
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}
                                                                                                        </span>{" "}
                                                                                                        -{" "}
                                                                                                        <span>
                                                                                                            {item.end_time}{" "}
                                                                                                            {getTimeImage(
                                                                                                                item.end_time
                                                                                                            ) ? (
                                                                                                                <img
                                                                                                                    src="localImages/moon.png"
                                                                                                                    className="star-imh-moon"
                                                                                                                    alt="time-image"
                                                                                                                />
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}{" "}
                                                                                                            {t("events.matchingPeriod")}
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <span class="sc-fyofxi-6 ivIeWB">
                                                                                                <span class="sc-fyofxi-5 gJmuwa godemantevent-activeevent-info-heading font-size-20">
                                                                                                    {tc(item.name)}
                                                                                                </span>
                                                                                                {/* <span class="sc-fyofxi-5 gJmuwa">Resch Center</span> */}
                                                                                            </span>
                                                                                            <span class="sc-fyofxi-7 jWLmQR">
                                                                                                <span class="sc-fyofxi-5 gJmuwa">
                                                                                                    {tc(item.subtext)}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div
                                                                                            onClick={() =>
                                                                                                getClientProfileDetails(item, index)
                                                                                            }
                                                                                            className="more-info-go-ondemand-practice d-flex align-items-center"
                                                                                        >
                                                                                            <span className="inline-block">
                                                                                                {t("events.moreDetails")}
                                                                                            </span>
                                                                                            <img
                                                                                                src={
                                                                                                    "./ondemand-icons/arrow-icon-black.png"
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="godemantevent-date-box godemantevent-date-button-box text-right">
                                                                                        <div className="godemantevent-date-button-box-before"></div>
                                                                                        <div className="ondemand-button-box">
                                                                                            {/* () => { } */}
                                                                                            {fifteenMinutesBefore(item) && (
                                                                                                <a
                                                                                                    onClick={
                                                                                                        item.is_event_started
                                                                                                            ? () =>
                                                                                                                checkMediumInOnDemand(
                                                                                                                    item
                                                                                                                )
                                                                                                            : () =>
                                                                                                                openReminderPopup(item)
                                                                                                    }
                                                                                                    href="#"
                                                                                                    className={`  kCQEIv indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block border-radius-40 ${item.is_event_started
                                                                                                        ? "Green-bg-all"
                                                                                                        : ""
                                                                                                        }`}
                                                                                                >
                                                                                                    <span class="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv">
                                                                                                        <span class="indexstyles__Text-sc-83qv1q-2 jHTUWf d-flex align-items-center">
                                                                                                            <img
                                                                                                                className="w-20-px  mr-2"
                                                                                                                src={`${!item.is_event_started
                                                                                                                    ? "/ondemand-icons/clock-icon.png"
                                                                                                                    : "/ondemand-icons/find-icon.png"
                                                                                                                    }`}
                                                                                                                alt="alarm"
                                                                                                            />
                                                                                                            {/* <svg
                                              class="BaseSvg-sc-yh8lnd-0 ChevronIcon___StyledBaseSvg-sc-1y4em6t-0 ckLyyv sc-1qeub3n-2 bcqnRP"
                                              viewBox="0 0 24 24"
                                              width="1.5em"
                                              height="1.5em"
                                              aria-hidden="true"
                                              focusable="false"
                                            >
                                              <path d="M3.47 8.26 4.53 7.2 12 14.67l7.47-7.47 1.06 1.06L12 16.8z"></path>
                                            </svg> */}
                                                                                                            <span class="sc-1qeub3n-6 iwMkwK">
                                                                                                                <span class="sc-1qeub3n-5 eTlzst">
                                                                                                                    {item.is_event_started
                                                                                                                        ? t("events.findPartner")
                                                                                                                        : t("events.remindMe")}
                                                                                                                </span>
                                                                                                            </span>
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </a>
                                                                                            )}
                                                                                            {!item.is_event_started && (
                                                                                                <a
                                                                                                    onClick={() => openTimer(item)}
                                                                                                    href="#"
                                                                                                    class="width-175-px kCQEIv disabled-btn-join cursor-disabled indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4 lmaHQg d-block mt-2 border-radius-40 ondemand-diabled"
                                                                                                >
                                                                                                    <span class="indexstyles__FlexWrapper-sc-83qv1q-1 kCQEIv ondemand-diabled">
                                                                                                        <span class="indexstyles__Text-sc-83qv1q-2 jHTUWf">
                                                                                                            <span class="sc-1qeub3n-6 iwMkwK  d-flex align-items-center">
                                                                                                                <img
                                                                                                                    className="w-20-px mr-2"
                                                                                                                    src={`${item.is_event_started
                                                                                                                        ? "/ondemand-icons/clock-icon.png"
                                                                                                                        : "/ondemand-icons/find-icon.png"
                                                                                                                        }`}
                                                                                                                    alt="alarm"
                                                                                                                />
                                                                                                                <span class="sc-1qeub3n-5 eTlzst ">
                                                                                                                    {t("events.findPartner")}
                                                                                                                </span>
                                                                                                                {/* <svg
                                                class="BaseSvg-sc-yh8lnd-0 ChevronIcon___StyledBaseSvg-sc-1y4em6t-0 ckLyyv sc-1qeub3n-2 bcqnRP"
                                                viewBox="0 0 24 24"
                                                width="1.5em"
                                                height="1.5em"
                                                aria-hidden="true"
                                                focusable="false"
                                              >
                                                <path d="M3.47 8.26 4.53 7.2 12 14.67l7.47-7.47 1.06 1.06L12 16.8z"></path>
                                              </svg> */}
                                                                                                            </span>
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </a>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                                </>
                                                            ))

                                                        :
                                                        <div className="d-flex align-items-center justify-content-center text-center">

                                                            <p className="font-size-18">{t("events.noEvents")}</p>
                                                        </div>}
                                                </ul>
                                                {(!disableLoadMore) && <div className="d-flex align-items-center justify-content-center mt-5">
                                                    <div
                                                        onClick={loadMoreItems}
                                                        className="width-175-px pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                                                    >
                                                        {t("events.loadMore")}
                                                    </div>
                                                </div>}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <CountdownTimer counterStatus={counterStatus} hideCountdownTimer={hideCountdownTimer} /> */}
                        </div>
                    </div>
                )}
                {loaderType == "7" && (
                    <CacheStep
                        startLoaderOndemand={startLoaderOndemand}
                        onCancelQuestions={() => setloaderType("1")}
                    />
                )}
                {loaderType == "2" && (
                    <Questions
                        setCheckYesMain={setCheckYes}
                        startLoaderNow={startLoaderNow}
                        onCancelQuestions={() => setloaderType("1")}
                    />
                )}

                {loaderType == "4" && (
                    <div className="ondemandpractice-wrapper margin-auto min-height-500px mt-5">
                        <div className="">
                            <div className="godemantevent-box-list">
                                <p className="text-center mt-5 font-size-26">
                                    {" "}
                                    {t("matched.confirmed")}
                                </p>

                                {shoHostStatus && (
                                    <h3 className="text-center mt-5 line-height-32px">
                                        <Trans i18nKey="matched.hostNotice" ns="clientOnDemand" t={t} />
                                    </h3>
                                )}
                                {/* <p className="text-center mt-4 font-size-19">{message}</p> */}
                                <p className="text-center mt-4 font-size-19">
                                    {t("matched.joinWithin")}
                                </p>
                                {counterStatus && (
                                    <CountdownTimerReact
                                        hideCountdownTimer={hideCountdownTimer}
                                        meeting_link={meeting_link}
                                        getZoomLink={getZoomLink}
                                        appoinmentId={appoinmentId}
                                    />
                                )}
                                {/* <p className="text-center mt-3 font-size-19">
                You can either joining the session now, or go to your
                appointments
                <br /> page to find the zoom link to join the session.
              </p> */}
                            </div>
                            <br />
                            {(meeting_link == "" ||
                                meeting_link == null ||
                                meeting_link == undefined) && (
                                    <div className="text-center mb-3 mt-1">
                                        <b> {t("matched.zoomCreating")}</b>
                                    </div>
                                )}
                            {/* {meeting_link !== "" && */}
                            {/* // meeting_link !== null &&
              // meeting_link !== undefined && ( */}
                            <div className="d-flex align-items-center justify-content-center flex-column">
                                {console.log(meeting_link, "meeting_link")}
                                {/* {meeting_link !== "" && ( */}
                                <a
                                    href={
                                        meeting_link !== "" &&
                                            meeting_link !== null &&
                                            meeting_link !== undefined
                                            ? meeting_link
                                            : "javascript:void();"
                                    }
                                    target={
                                        meeting_link !== "" &&
                                            meeting_link !== null &&
                                            meeting_link !== undefined
                                            ? "_blank"
                                            : ""
                                    }
                                    // onClick={() => {

                                    //   setloaderType('1'); setTime(0);
                                    //   setOndamandStatus(false)
                                    // }}
                                    className={`${meeting_link !== "" &&
                                        meeting_link !== null &&
                                        meeting_link !== undefined
                                        ? ""
                                        : "disabled-btn-join"
                                        } width-415-px  font-size-22 pointer mb-3  indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center`}
                                >
                                    {t("matched.joinZoomSession")}
                                </a>
                                {/* )} */}
                                <div
                                    onClick={() => {
                                        navigate("/appointments?from=goondemand");
                                        setloaderType("1");
                                        setTime(0);
                                        setOndamandStatus(false);
                                    }}
                                    className="width-415-px  pointer margin-unset indexstyles__StyledButton-sc-83qv1q-0 jdbotF-blacnk sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                                >
                                    {!shoHostStatus
                                        ? t("matched.findLinkInAppointments")
                                        : t("matched.preferFindLink")}
                                </div>
                            </div>
                            {/* // )} */}

                            <div className="d-flex align-items-center justify-content-center mt-5 go-ondemand-practice-hover">
                                <div className="col-md-4 hoverContent">
                                    <div className="hover-container d-flex justify-content-center ">
                                        {t("matched.havingIssues")}{" "}
                                        <p className="hover-target" tabindex="0">
                                            <img src="/images/qu.png" className="ondemant-i-btn" />
                                        </p>
                                        <aside className="hover-popup-r">
                                            <p className="mainpre">
                                                {t("matched.downloadZoom")}
                                            </p>
                                            <p className="mainpre">
                                                <Trans
                                                    i18nKey="matched.contactUs"
                                                    ns="clientOnDemand"
                                                    t={t}
                                                    components={{ a: <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank" /> }}
                                                />
                                            </p>
                                        </aside>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {loaderType == "5" && (
                    <ChooseMedium
                        rejectPaired={rejectPaired}
                        acceptPaired={acceptPaired}
                        hangon={hangon}
                        seconds={seconds}
                        matchName={matchName}
                    />
                )}
                {/* {console.log(activeEvent, "timeLeft")} */}
                <ScheduledetailsModal
                    info={info}
                    setloaderType={setloaderType}
                    Index={Index}
                    checkMediumInOnDemand={checkMediumInOnDemand}
                    cacheCheck={cacheCheck}
                    bookDirectAppointment={bookDirectAppointment}
                />
                <ReminderPopUp activeEvent={activeEvent} />
                <ExitQueuePopup onYesClick={ExitQueue} />
                <AlredyJoined checkONdemandMessage={checkONdemandMessage} />
                <ConfirmOut />
                <TimeEndedPopup setloaderType={setloaderType} />
                <EmerGencyPopUp closePopup={closePopup} />
                <BookAppointmentPopUp
                    directAppMediumInfo={directAppMediumInfo}
                    booKGroupEvent={booKGroupEventconfirm}
                    isBookingInProgress={isBookingInProgress}
                />
                <QuestionPopUp
                    directAppMediumInfo={directAppMediumInfo}
                    booKGroupEvent={booKGroupEvent}
                    isBookingInProgress={isBookingInProgress}
                />
                <BookingConfirmPopUp
                continueBrowsing={continueBrowsing}
                directAppMediumInfo={directAppMediumInfo}
                slotDetails={slotDetails}
                userDetails={userDetails}
                />
                {loaderType == "6" && (
                    <PartnerEndedPopup
                        matchName={matchName}
                        addMediumToQueueAgain={addMediumToQueueAgain}
                    />
                )}
                <PayOptionsPopUp createBooking={createBooking} paymentInfo={mediumValue} />
                <PayItForwardPopUp
                    activePay={activePay}
                    paymentMethodHandler={payItForwardHandler}
                    setpayItforwardValue={setpayItforwardValue}
                    setPaymentCurrency={setPaymentCurrency}
                    payItforwardFixPrice={payItforwardFixPrice}
                    paymentstatus={paymentstatus}
                    payItforwardValue={payItforwardValue}
                />
                {loaderType == "CONFIRM" && (
                    <BookingConfirm slotDetails={slotDetails} userDetails={userDetails} />
                )}
                {activeEvent !== undefined && <TimerForEvent activeEvent={activeEvent} />}
                {openModal && <SeVideoPopUp setOpenModal={setOpenModal} url={url} yturl={yturl} />}
            </>
        </>
    );
}
